import { useEffect, useMemo, useRef, useState } from "react";
import { JahrgangDetail } from "./ansichten/jahrgang.jsx";
import { KellerAnsicht } from "./ansichten/keller.jsx";
import { RegionDetail, RegionenAnsicht } from "./ansichten/regionen.jsx";
import { StatistikAnsicht } from "./ansichten/statistik.jsx";
import { WeinDetail } from "./ansichten/wein.jsx";
import { WeineAnsicht } from "./ansichten/weine.jsx";
import { WinzerAnsicht, WinzerDetail } from "./ansichten/winzer.jsx";
import { etikettenAufraeumen, etikettenVorladen, fehlendeEtiketten } from "./dienste/etiketten.js";
import { alleFotoPfade, fotoUrlsVergessen, fotoWarteschlangeAnzahl, fotoWarteschlangeSenden, fotosLoeschen, jahrgangBildPfade } from "./dienste/fotos.js";
import { baueImportDb, exportiereBestand, ladeVorlage, leseExcel } from "./dienste/impex.js";
import { ladeKlimareihe, ladeWitterung } from "./dienste/witterung.js";
import { wendeAn, wetterLauf, wetterPlan } from "./dienste/wetterlauf.js";
import { BewegungForm, EntnahmeForm, JahrgangForm, KritikForm, ZugangForm } from "./formulare/jahrgang.jsx";
import { RegionForm, WeinForm, WinzerForm } from "./formulare/stammdaten.jsx";
import { katalogLaden, uebernehmeRegion, uebernehmeWein, uebernehmeWinzer } from "./dienste/katalog.js";
import { KatalogUebernahme } from "./ui/katalogsuche.jsx";
import { TYP_ZU_KATALOG, alsLokalGefuehrt, gibFrei, gleich, katalogForm, kritikenTeilen, offeneVorschlaege, vorschlaegeHolen, vorschlaegeSenden, vorschlagZurueckziehen, wendeEntscheidungenAn, zurueckgehalten } from "./dienste/vorschlaege.js";
import { ersetzeOderErgaenze, mischeKatalog } from "./dienste/kuratorsicht.js";
import { gesperrteIds, offeneEntscheidungen } from "./dienste/dubletten.js";
import { AdminVorschlaege, MeineVorschlaege } from "./formulare/vorschlaege.jsx";
import { abweichungBehalten, abweichungUebernehmen, aufKatalogfassung, lueckenErgebnisse, merkeAbweichungen, offeneAbweichungen, protokollHolen, verarbeiteProtokoll } from "./dienste/historie.js";
import { Historie } from "./formulare/historie.jsx";
import { ZusammenfuehrenPanel } from "./formulare/zusammenfuehren.jsx";
import { RundumAufnahme } from "./formulare/rundum.jsx";
import { KontoPanel, VergessenFormular } from "./formulare/konto.jsx";
import { browserSprache, IST_SPRACHE, setzeSprache, SPRACHEN, t } from "./i18n/index.js";
import { Sprachwahl, useSprache } from "./i18n/haken.jsx";
import { TeilenPanel, WeinkartenPanel } from "./formulare/teilen.jsx";
import { AdminPanel, ImportBericht, KellerLoeschenForm, WetterLadenPanel } from "./formulare/verwaltung.jsx";
import { InfoPanel } from "./formulare/info.jsx";
import { SchnellKritikForm } from "./formulare/kritik.jsx";
import { TrinkverlaufPanel } from "./formulare/trinkverlauf.jsx";
import { SyncPanel } from "./formulare/sync.jsx";
import { apiLaden, apiSpeichern, apiVersion, ladeKonto, speichereKonto, vergissKonto } from "./kern/api.js";
import { hatLokal, ladeLokal, ladeWetter, speichereLokal, speichereWetter } from "./dienste/lokalkopie.js";
import { mitWetter, ohneWetter, serialisiere, wetterTeil } from "./kern/wetterteil.js";
import { bestandsDeltas, eindeutigeWerte, jahrgangFuer, ersetzeWartendeFotos, migriere, rebsortenListe, regionZuWein } from "./kern/fachlogik.js";
import { jahrLabel, sortDe, uid } from "./kern/format.js";
import { istOffeneKritik } from "./kern/kritik.js";
import { syncFall } from "./kern/sync.js";
import { fuehreDreiWegeZusammen } from "./kern/dreiwege.js";
import { ladeBasis, merkeBasis } from "./dienste/basisstand.js";
import { SCHEMATA, FLASCHENGROESSEN, NV, SEED } from "./kern/konstanten.js";
import { CSS } from "./stil.js";
import { ansichtSpeicher, usePersistentState } from "./ui/hooks.jsx";
import { Btn, Eingabe, Feld, Modal, ZurueckLeiste } from "./ui/primitive.jsx";



/** Markenzeichen „Granatsee": Gabriel-Silhouette mit nach oben
    verjüngten Wänden (gefüllte Formen, currentColor), leicht
    gefüllt; der Fuß ist ein geschwungener See aus Wein (Granat). */
/* Hat `migriere` den Stand tatsächlich angefasst? Der Vergleich ist
   grob (JSON über alles), läuft aber nur beim Laden — und nur so
   erfährt der Server von Ergänzungen, die die Migration vornimmt. */
function migrationVeraendert(roh, migriert) {
  /* Ohne Wetterteil: Der gehört nicht zum Kellerbuch (kern/wetterteil.js),
     ein ergänztes leeres `weatherCache` ist keine Änderung. */
  try { return serialisiere(roh) !== serialisiere(migriert); }
  catch (e) { return true; }
}


function Logo({ groesse = 40, className = "" }) {
  return (
    <svg className={"wl-logo" + (className ? " " + className : "")} width={groesse} height={groesse}
      viewBox="0 0 100 100" aria-hidden="true" focusable="false">
      <path fill="currentColor" d="M36.45,10 C34.2,20 31.8,30 31.8,38 C31.9,44.8 39.6,51.2 48.0,52.9 L49.2,51.1 C41.2,49.8 33.6,44.2 33.6,38 C33.6,30.4 35.7,20 37.55,10 Z"/>
      <path fill="currentColor" d="M63.55,10 C65.8,20 68.2,30 68.2,38 C68.1,44.8 60.4,51.2 52.0,52.9 L50.8,51.1 C58.8,49.8 66.4,44.2 66.4,38 C66.4,30.4 64.3,20 62.45,10 Z"/>
      <path fill="#722F37" d="M34.8,41 C40,42.4 60,42.4 65.2,41 C64.3,46 58.2,50.4 51,51.7 L49,51.7 C41.8,50.4 35.7,46 34.8,41 Z"/>
      <path fill="currentColor" d="M49.05,52 C49.05,51.6 50.95,51.6 50.95,52 L51.35,76.6 C51.35,77.3 48.65,77.3 48.65,76.6 Z"/>
      <path fill="#722F37" d="M24,83.5 C25,79.8 31,77.6 37.5,78.4 C41.5,78.9 44,77.1 48,76.7 C53,76.2 55.5,78.6 61,78.2 C67.5,77.8 74.5,79.2 76,82 C77.6,85 71.5,87.8 64,88.6 C57.5,89.3 52,87.9 46,88.5 C40,89.1 31.5,89 27,87 C24.2,85.8 23.4,84.6 24,83.5 Z"/>
    </svg>
  );
}


/** Hauptmenü links der Marke: Konto, Anzeige-Einstellung, Abmelden. */
/* Umfang der Listen — von eng nach weit. `alle` erscheint nur, wenn
   der Katalog verfügbar ist. */
const SICHTEN = [
  { key: "bestand", label: "Keller mit Bestand" },
  { key: "keller", label: "Gesamter Keller" },
  { key: "alle", label: "Alle Weine" },
];


function HauptMenue({ nutzer, abmelden, sync, onSync, ungesichert = false, wartendeFotos = 0, lokalFehler = false, modus, onModus, sprache = "de", onSprache, kritikSchema = "p100", kritikGeteilt = true, onKritikPrefs, katalogGesperrt = false, dubletten = 0, offeneAnzahl = 0, konflikte = 0, neuEntschieden = 0, adminOffen = 0, onVorschlaege, onAdminVorschlaege, onHistorie, onZusammenfuehren, sicht, setSicht, geheZuStatistik, onKonto, onTeilen, onWeinkarten, onKellerLoeschen, onExport, onVorlage, onImport, onWetter, onTrinkverlauf, onVerwaltung, onInfo }) {
  const syncText = {
    aktuell: t("Synchronisiert · Stand {v}", { v: sync ? sync.version : "" }),
    speichert: t("Wird gespeichert …"),
    pruefe: t("Prüfe …"),
    laden: t("Wird geladen …"),
    offline: t("Offline — lokal gesichert"),
    konflikt: t("Konflikt · bitte abgleichen"),
    fehler: (sync && sync.text) || t("Speichern fehlgeschlagen"),
  }[sync ? sync.status : "aktuell"] || "";
  /* Ungesicherte Änderungen sind der einzige Zustand, in dem ein
     Abgleich wirklich nötig ist — er gehört sichtbar in die Zeile. */
  const problem = lokalFehler || (sync && sync.status === "fehler");
  const standText = lokalFehler
    ? t("Lokale Kopie konnte nicht gespeichert werden")
    : sync && sync.status === "fehler" ? syncText
    : wartendeFotos > 0
    ? t.plural(wartendeFotos, "Ein Foto wartet auf Übertragung", "{n} Fotos warten auf Übertragung")
    : (ungesichert && sync && sync.status !== "speichert"
        ? t("Lokale Änderungen · noch nicht übertragen")
        : syncText);
  const laedt = sync && (sync.status === "laden" || sync.status === "speichert" || sync.status === "pruefe");

  const [offen, setOffen] = useState(false);
  /* null = Hauptebene, sonst der Name der geöffneten Gruppe. */
  const [gruppe, setGruppe] = useState(null);
  const ref = useRef(null);

  const schliessen = () => { setOffen(false); setGruppe(null); };

  useEffect(() => {
    if (!offen) return;
    const klick = (e) => { if (ref.current && !ref.current.contains(e.target)) schliessen(); };
    const taste = (e) => { if (e.key === "Escape") { if (gruppe) setGruppe(null); else schliessen(); } };
    window.addEventListener("mousedown", klick);
    window.addEventListener("keydown", taste);
    return () => {
      window.removeEventListener("mousedown", klick);
      window.removeEventListener("keydown", taste);
    };
  }, [offen, gruppe]);

  const katalogAn = modus === "cloud" && !katalogGesperrt;
  /* Am Gruppenpunkt zählt nur, was eine Handlung verlangt oder neu
     ist — offene eigene Vorschläge warten auf andere. */
  const katalogZaehler = katalogAn ? konflikte + neuEntschieden + (nutzer.istAdmin ? adminOffen : 0) : 0;

  /* Ein Menüpunkt, der etwas ausführt und das Menü schließt. */
  const Punkt = ({ label, onClick, gefahr = false, zaehler = 0, marke = null }) => (
    <button className={"wl-hm-punkt" + (gefahr ? " wl-hm-punkt--gefahr" : "")}
      onClick={() => { schliessen(); onClick(); }}>
      {label}
      {marke && <span className="wl-hm-marke">{marke}</span>}
      {zaehler > 0 && <span className="wl-hm-zaehler">{zaehler}</span>}
    </button>
  );

  /* Ein Punkt, der eine Untergruppe öffnet. */
  const Gruppe = ({ name, label, zaehler = 0, marke = null }) => (
    <button className="wl-hm-punkt wl-hm-gruppe" onClick={() => setGruppe(name)}>
      <span>{label}</span>
      {marke && <span className="wl-hm-marke">{marke}</span>}
      {zaehler > 0 && <span className="wl-hm-zaehler">{zaehler}</span>}
      <span className="wl-hm-pfeil" aria-hidden="true">›</span>
    </button>
  );

  const Zurueck = ({ titel }) => (
    <button className="wl-hm-zurueck" onClick={() => setGruppe(null)}>
      <span aria-hidden="true">‹</span> {titel}
    </button>
  );

  return (
    <div className="wl-hauptmenue" ref={ref}>
      <button className={"wl-hm-knopf" + (offen ? " ist-offen" : "")}
        aria-label={t("Menü")} aria-expanded={offen}
        onClick={() => { setOffen((o) => !o); setGruppe(null); }}>
        <span className="wl-hm-icon" aria-hidden="true"><i /><i /><i /></span>
      </button>

      {offen && (
        <div className="wl-hm-panel">
          {gruppe === null && (
            <>
              <div className="wl-hm-kopf">
                <span className="wl-hm-name">
                  {nutzer.benutzername}
                  {nutzer.istAdmin && <span className="wl-adminmarke">{t("Admin")}</span>}
                </span>
              </div>

              <Punkt label={t("Statistik")} onClick={geheZuStatistik} />
              {/* Der Trinkverlauf ist die zweite Auswertung neben der
                  Statistik und gehört daneben — nicht in die Gruppe
                  „Daten“, wo es um Ein- und Ausfuhr geht. */}
              <Punkt label={t("Trinkverlauf")} onClick={onTrinkverlauf} />
              {/* Eine Wahl statt zweier Schalter: „Nur mit Bestand“ und
                  „Mein Keller / Alle“ beantworteten dieselbe Frage —
                  wie weit reicht die Liste. Als Kette gelesen wird sie
                  von eng nach weit: eigener Bestand, eigenes Kellerbuch,
                  alles Bekannte. */}
              <div className="wl-hm-sicht" role="group" aria-label={t("Umfang der Listen")}>
                <span className="wl-hm-label">{t("Anzeigen")}</span>
                {SICHTEN.filter((o) => o.key !== "alle" || katalogAn).map((o) => (
                  <button key={o.key} className={"wl-hm-sichtpunkt" + (sicht === o.key ? " aktiv" : "")}
                    aria-pressed={sicht === o.key} onClick={() => setSicht(o.key)}>
                    {t(o.label)}
                  </button>
                ))}
              </div>

              <div className="wl-hm-trenner" />
              <Gruppe name="konto" label={t("Mein Konto")} />
              {nutzer.darfWeinkarten && <Gruppe name="teilen" label={t("Teilen")} />}
              {katalogAn && <Gruppe name="katalog" label={t("Katalog")} zaehler={katalogZaehler} />}
              <Gruppe name="daten" label={t("Daten")}
                marke={problem ? "!" : (ungesichert || wartendeFotos > 0) ? t("lokal") : (sync && sync.status === "offline" ? "offline" : null)} />
              <Punkt label={t("Info")} onClick={onInfo} />
              {nutzer.istAdmin && <Punkt label={t("Verwaltung")} onClick={onVerwaltung} />}
            </>
          )}

          {gruppe === "konto" && (
            <>
              <Zurueck titel={t("Mein Konto")} />
              <Punkt label={t("E-Mail & Passwort")} onClick={onKonto} />
              <div className="wl-hm-modus">
                <span className="wl-hm-label">{t("Sprache")}</span>
                <Sprachwahl wert={sprache} sprachen={SPRACHEN}
                  onWechsel={(c) => onSprache && onSprache(c)} />
                <span className="wl-hm-modushinweis">
                  {t("Gilt für die Oberfläche sowie für Zahlen-, Datums- und Währungsangaben.")}
                </span>
              </div>
              {/* Kritik-Einstellungen stehen hier und nicht im Dialog
                  „E-Mail & Passwort“: Sie betreffen den Umgang mit
                  Kritiken, nicht die Zugangsdaten. */}
              <div className="wl-hm-modus">
                <span className="wl-hm-label">{t("Kritiken")}</span>
                <select className="wl-hm-schemawahl" value={kritikSchema}
                  onChange={(e) => onKritikPrefs({ schema: e.target.value })}
                  aria-label={t("Standard-Bewertungsschema")}>
                  {Object.entries(SCHEMATA).map(([k, v]) => (
                    <option key={k} value={k}>{t(v.label)}</option>
                  ))}
                </select>
                <label className="wl-hm-schalter wl-hm-teilen">
                  <input type="checkbox" checked={kritikGeteilt}
                    onChange={(e) => onKritikPrefs({ geteilt: e.target.checked })} />
                  {t("Im gemeinsamen Katalog zeigen")}
                </label>
                <span className="wl-hm-modushinweis">
                  {kritikGeteilt
                    ? t("Bewertung, Kritiker, Speisenbegleitung und Notiz sind für alle Konten sichtbar — samt deinem Benutzernamen. Der Anlass bleibt privat, ebenso Bestände, Lagerorte und Preise.")
                    : t("Deine Kritiken bleiben in deinem Kellerbuch.")}
                </span>
              </div>
              <div className="wl-hm-modus">
                <span className="wl-hm-label">{t("Datenhaltung")}</span>
                <div className="wl-hm-modusschalter" role="group" aria-label={t("Kontomodus")}>
                  <button className={modus === "cloud" ? "aktiv" : ""} onClick={() => onModus("cloud")}>{t("Cloud")}</button>
                  <button className={modus === "lokal" ? "aktiv" : ""} onClick={() => onModus("lokal")}>{t("Lokal")}</button>
                </div>
                <span className="wl-hm-modushinweis">
                  {katalogGesperrt
                    ? t("Die Katalog-Synchronisation wurde für dieses Konto abgeschaltet. Deine eigenen Daten bleiben nutzbar.")
                    : modus === "cloud"
                      ? t("Stammdaten aus dem gemeinsamen Katalog übernehmen.")
                      : t("Nur deine eigenen Daten, kein Katalog.")}
                </span>
              </div>
              <div className="wl-hm-trenner" />
              <Punkt label={t("Abmelden")} onClick={abmelden} />
              <Punkt label={t("Keller löschen")} onClick={onKellerLoeschen} gefahr />
            </>
          )}

          {gruppe === "teilen" && (
            <>
              <Zurueck titel={t("Teilen")} />
              <Punkt label={t("Keller teilen")} onClick={onTeilen} />
              <Punkt label={t("Weinkarten")} onClick={onWeinkarten} />
            </>
          )}

          {gruppe === "katalog" && (
            <>
              <Zurueck titel={t("Katalog")} />
              <Punkt label={t("Änderungen")} onClick={onHistorie} zaehler={konflikte} />
              <Punkt label={t("Meine Vorschläge")} onClick={onVorschlaege} zaehler={offeneAnzahl}
                marke={neuEntschieden > 0 ? t("neu") : null} />
              {nutzer.istAdmin && <Punkt label={t("Vorschläge prüfen")} onClick={onAdminVorschlaege} zaehler={adminOffen} />}
            </>
          )}

          {gruppe === "daten" && (
            <>
              <Zurueck titel={t("Daten")} />
              <div className="wl-hm-standzeile">
                <span className="wl-hm-label">{t("Datenstand")}</span>
                <span className={"wl-hm-stand" + (problem ? " ist-fehler" : (ungesichert || wartendeFotos > 0 || (sync && sync.status === "offline")) ? " ist-offline" : "")}>
                  {standText}
                </span>
              </div>
              <button className="wl-hm-punkt" disabled={laedt}
                onClick={() => { schliessen(); onSync(); }}>
                {laedt ? t("Wird geladen …") : t("Daten synchronisieren")}
                {(ungesichert || wartendeFotos > 0) && <span className="wl-hm-marke">{t("lokal")}</span>}
              </button>
              <div className="wl-hm-trenner" />
              <Punkt label={t("Zusammenführen")} onClick={onZusammenfuehren} zaehler={dubletten} />
              {nutzer.darfWetter && <Punkt label={t("Wetterdaten laden")} onClick={onWetter} />}
              <div className="wl-hm-trenner" />
              <Punkt label={t("Excel exportieren")} onClick={onExport} />
              <Punkt label={t("Excel importieren")} onClick={onImport} />
              <Punkt label={t("Leere Vorlage")} onClick={onVorlage} />
            </>
          )}
        </div>
      )}
    </div>
  );
}


/** Anmeldung & Registrierung — jeder Nutzer führt sein eigenes,
    nur für ihn sichtbares Kellerbuch. */
function AnmeldeAnsicht({ onAngemeldet }) {
  const [modus, setModus] = useState("anmelden");
  const [w, setW] = useState({ benutzername: "", passwort: "", wiederholung: "", code: "", email: "" });
  const [fehler, setFehler] = useState(null);
  const [laeuft, setLaeuft] = useState(false);
  const [codeNoetig, setCodeNoetig] = useState(false);
  const [resetMoeglich, setResetMoeglich] = useState(false);
  const setze = (k) => (e) => setW({ ...w, [k]: e.target.value });

  useEffect(() => {
    let aktiv = true;
    (async () => {
      try {
        const r = await fetch("/api/konfiguration");
        if (!aktiv || !r.ok) return;
        const k = await r.json();
        setCodeNoetig(!!k.einladungscode);
        setResetMoeglich(!!k.passwortResetMoeglich);
      } catch (e) { /* Standard: kein Code erforderlich */ }
    })();
    return () => { aktiv = false; };
  }, []);

  const absenden = async () => {
    if (laeuft) return;
    setFehler(null);
    if (!w.benutzername.trim()) return setFehler("Bitte einen Benutzernamen angeben.");
    if (!w.passwort) return setFehler("Bitte ein Passwort angeben.");
    if (modus === "registrieren") {
      if (!w.email.trim()) return setFehler("Bitte eine E-Mail-Adresse angeben.");
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(w.email.trim())) {
        return setFehler("Diese E-Mail-Adresse sieht nicht gültig aus.");
      }
      if (w.passwort.length < 8) return setFehler("Das Passwort braucht mindestens 8 Zeichen.");
      if (w.passwort !== w.wiederholung) return setFehler("Die Passwörter stimmen nicht überein.");
      if (codeNoetig && !w.code.trim()) return setFehler("Bitte den Einladungscode angeben.");
    }
    setLaeuft(true);
    try {
      const r = await fetch(modus === "anmelden" ? "/api/anmelden" : "/api/registrieren", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          benutzername: w.benutzername.trim(),
          passwort: w.passwort,
          code: w.code.trim(),
          email: w.email.trim(),
        }),
      });
      const json = await r.json().catch(() => ({}));
      if (!r.ok) {
        setFehler(json.fehler || "Das hat nicht geklappt — bitte erneut versuchen.");
        return;
      }
      onAngemeldet(json);
    } catch (e) {
      setFehler("Der Server ist nicht erreichbar — bitte Verbindung prüfen.");
    } finally {
      setLaeuft(false);
    }
  };

  return (
    <div className="wl-anmeldung" onKeyDown={(e) => { if (e.key === "Enter") absenden(); }}>
      <div className="wl-anmeldekarte">
        <Logo groesse={56} className="wl-anmeldelogo" />
        <span className="wl-marke">WineLake</span>
        <span className="wl-unterzeile">Kellerbuch &amp; Jahrgangsarchiv</span>
        {modus === "vergessen" ? (
          <VergessenFormular onZurueck={() => { setModus("anmelden"); setFehler(null); }} />
        ) : (
        <>
        <div className="wl-anmeldewechsel" role="tablist">
          <button role="tab" aria-selected={modus === "anmelden"}
            className={modus === "anmelden" ? "aktiv" : ""}
            onClick={() => { setModus("anmelden"); setFehler(null); }}>{t("Anmelden")}</button>
          <button role="tab" aria-selected={modus === "registrieren"}
            className={modus === "registrieren" ? "aktiv" : ""}
            onClick={() => { setModus("registrieren"); setFehler(null); }}>{t("Registrieren")}</button>
        </div>
        <div className="wl-anmeldefelder">
          <Feld label={modus === "anmelden" ? "Benutzername oder E-Mail" : "Benutzername"}>
            <Eingabe value={w.benutzername} onChange={setze("benutzername")} autoFocus autoComplete="username" />
          </Feld>
          {modus === "registrieren" && (
            <Feld label={t("E-Mail")}>
              <Eingabe type="email" value={w.email} onChange={setze("email")}
                autoComplete="email" placeholder="name@beispiel.de" />
            </Feld>
          )}
          <Feld label={t("Passwort")}>
            <Eingabe type="password" value={w.passwort} onChange={setze("passwort")}
              autoComplete={modus === "anmelden" ? "current-password" : "new-password"} />
          </Feld>
          {modus === "registrieren" && (
            <Feld label={t("Passwort wiederholen")}>
              <Eingabe type="password" value={w.wiederholung} onChange={setze("wiederholung")} autoComplete="new-password" />
            </Feld>
          )}
          {modus === "registrieren" && codeNoetig && (
            <Feld label={t("Einladungscode")}>
              <Eingabe value={w.code} onChange={setze("code")} />
            </Feld>
          )}
        </div>
        {fehler && <p className="wl-fehler">{fehler}</p>}
        <Btn variante="voll" className="wl-anmeldeknopf" onClick={absenden} disabled={laeuft}>
          {laeuft ? "Einen Moment …" : modus === "anmelden" ? "Anmelden" : "Konto anlegen"}
        </Btn>
        {modus === "anmelden" && resetMoeglich && (
          <button className="wl-textknopf wl-konto-zurueck"
            onClick={() => { setModus("vergessen"); setFehler(null); }}>{t("Passwort vergessen?")}</button>
        )}
        <p className="wl-anmeldehinweis">
          {modus === "anmelden"
            ? "Noch kein Konto? Oben auf Registrieren wechseln."
            : "Die E-Mail-Adresse brauchst du, falls du dein Passwort einmal zurücksetzen musst."}
        </p>
        </>
        )}
      </div>
    </div>
  );
}


/* §7 ─ App-Shell ──────────────────────────────────────────────── */

function WineLake() {
  const [db, setDb] = useState(null);
  const [verlauf, setVerlauf] = useState([{ view: "keller" }]);
  const route = verlauf[verlauf.length - 1];
  const kannZurueck = verlauf.length > 1;
  const [modal, setModal] = useState(null);
  const dateiRef = useRef(null);
  const [impexStatus, setImpexStatus] = useState(null); /* {typ:'laed'|'fehler', text} */
  const [wetterStatus, setWetterStatus] = useState(null); /* {phase, ...} */
  const [sync, setSync] = useState({ status: "laden", version: 0 });
  const versionRef = useRef(0);
  const zuletztGespeichert = useRef(null); /* JSON des zuletzt bestätigten Standes */
  /* Gesetzt, solange ein Versionskonflikt auf die Entscheidung des
     Nutzers wartet: { version, daten } des Serverstandes. */
  const offenerKonflikt = useRef(null);
  /* Der zuletzt mit dem Server bestätigte Stand { version, daten } —
     Ausgangspunkt der Dreiwegezusammenführung (kern/dreiwege.js).
     Liegt zusätzlich in IndexedDB (dienste/basisstand.js), damit er
     einen Neustart übersteht. */
  const basisRef = useRef(null);

  /* Konto: null = Sitzung wird geprüft, false = abgemeldet, sonst { benutzername } */
  const [nutzer, setNutzer] = useState(null);

  /* Ungesicherte Änderungen: gilt, solange der aktuelle Stand nicht
     bestätigt zurückgeschrieben wurde. `zuletztGespeichert === null`
     heißt „noch nie bestätigt" (frischer Start aus einer als
     ungesichert markierten lokalen Kopie). */
  const [ungesichert, setUngesichert] = useState(false);
  const merkeStand = (bestaetigt) => {
    zuletztGespeichert.current = bestaetigt;
    setUngesichert(bestaetigt === null);
  };

  useEffect(() => {
    let aktiv = true;
    (async () => {
      try {
        const r = await fetch("/api/ich");
        if (!aktiv) return;
        if (r.ok) {
          const konto = await r.json();
          speichereKonto(konto);
          setNutzer(konto);
          return;
        }
        /* 401: die Sitzung ist wirklich abgelaufen. Das gemerkte Konto
           wird verworfen, die lokale Kopie des Kellerbuchs bleibt
           liegen — sie gehört dem Nutzer, nicht der Sitzung. */
        vergissKonto();
        setNutzer(false);
      } catch (e) {
        /* Kein Netz. Mit dem zuletzt angemeldeten Konto weiterarbeiten,
           sofern dafür überhaupt ein lokaler Stand existiert; sonst
           wäre die Anmeldemaske ehrlicher. */
        if (!aktiv) return;
        const konto = ladeKonto();
        const lokal = konto ? await hatLokal(konto.benutzername) : false;
        if (!aktiv) return;
        setNutzer(konto && lokal ? konto : false);
      }
    })();
    return () => { aktiv = false; }; /* einmalige Sitzungsprüfung */
  }, []);

  const abmelden = async () => {
    try { await fetch("/api/abmelden", { method: "POST" }); } catch (e) { /* egal */ }
    /* Gespeicherte Ansichtszustände (Filter/Sortierung) verwerfen */
    for (const k of Object.keys(ansichtSpeicher)) delete ansichtSpeicher[k];
    fotoUrlsVergessen();
    vergissKonto();
    setDb(null);
    setModal(null);
    setVerlauf([{ view: "keller" }]);
    setSync({ status: "laden", version: 0 });
    versionRef.current = 0;
    /* Katalogabgleich gehört zur Sitzung des Kontos. */
    katalogStartGelaufen.current = false;
    gemeldeteEntscheidungen.current = new Set();
    katalogVersionRef.current = null;
    protokollStandRef.current = -1;
    setKatalog(null);
    setHistorie([]);
    setAdminOffen(0);
    merkeStand(null);
    setUngesichert(false);
    setLokalFehler(false);
    wetterRef.current = null;
    basisRef.current = null;
    setNutzer(false);
  };

  /* Abgelaufene Sitzung: zurück zur Anmeldung */
  const sitzungVerloren = () => {
    vergissKonto();
    setDb(null);
    setModal(null);
    setNutzer(false);
  };

  /* `lokalStand`: der Stand, auf dem die Entscheidung zum Herunterladen
     beruhte. Hat der Nutzer seither weitergetippt, wird sein neuester
     Stand dreifach auf den Serverstand gesetzt, statt verworfen. */
  const uebernehmeServerStand = (version, daten, lokalStand = null) => {
    /* Der Wetterteil bleibt auf dem Gerät — ein Serverstand bringt ihn
       nicht (mehr) mit. Ältere Serverstände tragen ihn noch; dann
       ergänzen sich beide. */
    const d = mitWetter(migriere(daten), wetterRef.current, wetterTeil(dbRef.current));
    offenerKonflikt.current = null;
    versionRef.current = version;
    /* Hat die Migration etwas verändert — etwa `istEigene` an alten
       Kritiken ergänzt —, darf der Stand NICHT als bestätigt gelten.
       Sonst bliebe die Ergänzung für immer im Browser und käme nie
       zum Server; ein zweites Gerät sähe sie nie. `null` heißt
       „ungesichert“ und lässt den Speichereffekt anlaufen. */
    const text = serialisiere(d);
    merkeStand(migrationVeraendert(daten, d) ? null : text);
    lokalAblegen({ version, daten: d }, text);
    merkeBestaetigt(version, d);
    if (lokalStand) {
      setDb((prev) => (!prev || prev === lokalStand ? d : fuehreDreiWegeZusammen(lokalStand, prev, d).db));
    } else {
      setDb(d);
    }
    setSync({ status: "aktuell", version });
    return d;
  };

  const merkeBestaetigt = (version, stand) => {
    const ohne = ohneWetter(stand);
    basisRef.current = { version, daten: ohne };
    merkeBasis(nutzer.benutzername, version, ohne);
  };

  /* Lokale Kopie ablegen und einen Fehlschlag sichtbar machen — früher
     wurde er verschluckt (dienste/lokalkopie.js). */
  const [lokalFehler, setLokalFehler] = useState(false);
  const lokalAblegen = (stand, text = null) => {
    if (!nutzer) return;
    speichereLokal(nutzer.benutzername, stand, text).then((ok) => setLokalFehler(!ok));
  };

  /* Zuletzt bekannter Wetterteil — auch für Serverstände, die ihn
     nicht mitbringen. Getrennt abgelegt, sobald er sich ändert. */
  const wetterRef = useRef(null);

  /* Gegenstück: der lokale Stand ist auf dem Server angekommen. */
  const uebernehmeLokalenStand = (version, stand, serialisiert) => {
    offenerKonflikt.current = null;
    versionRef.current = version;
    const text = serialisiert != null ? serialisiert : serialisiere(stand);
    merkeStand(text);
    lokalAblegen({ version, daten: stand }, text);
    merkeBestaetigt(version, stand);
    setSync({ status: "aktuell", version });
  };

  /* ── Zusammenführen bei Versionskonflikt ─────────────────────────
     Antwortet der Server mit 409, haben Gerät und Server seit dem
     letzten Abgleich beide etwas geändert. Mit bekannter Basis wird
     zuerst dreifach zusammengeführt; nur echte Widersprüche (dasselbe
     Feld verschieden geändert, gelöscht gegen geändert, ein Bestand
     unter null) landen beim Nutzer. Ohne Basis bleibt es bei der
     Wahl eines Standes — dann sähe eine Löschung wie eine Neuanlage
     auf der anderen Seite aus.

     `lokalStand` ist der Stand, der gerade geschrieben werden sollte.
     Hat der Nutzer währenddessen weitergetippt, wird sein neuester
     Stand auf das Ergebnis gesetzt (wieder dreifach, mit
     `lokalStand` als Basis) — nichts Getipptes geht verloren. */
  const zusammenfuehrenMoeglich = () => !!basisRef.current && basisRef.current.version === versionRef.current;

  const zusammengefuehrtUebernehmen = (version, zusammen, lokalStand) => {
    uebernehmeLokalenStand(version, zusammen);
    setDb((prev) => (prev === lokalStand || !prev
      ? zusammen
      : fuehreDreiWegeZusammen(lokalStand, prev, zusammen).db));
  };

  /** Liefert { zusammengefuehrt: ergebnis, version } oder
      { konflikt: true }. Mit `beiKonflikt` werden auch Widersprüche
      aufgelöst (Entscheidung des Nutzers im Dialog). */
  const nachVersionskonflikt = async (serverVersion, serverDatenRoh, lokalStand,
    { dialog = true, beiKonflikt = null, versuch = 0, basis } = {}) => {
    /* Die Basis wird beim ersten Durchgang festgelegt und bleibt —
       sie ist der gemeinsame Ausgangspunkt, auch wenn der Server
       inzwischen weitergelaufen ist. */
    const ausgang = basis !== undefined ? basis : (zusammenfuehrenMoeglich() ? basisRef.current.daten : null);
    const serverDaten = migriere(serverDatenRoh);
    const ergebnis = ausgang
      ? fuehreDreiWegeZusammen(ausgang, lokalStand, serverDaten, { beiKonflikt: beiKonflikt || "lokal" })
      : null;
    if (ergebnis && (ergebnis.konflikte.length === 0 || beiKonflikt)) {
      const antwort = await apiSpeichern(serverVersion, ergebnis.db);
      if (!antwort.konflikt) {
        zusammengefuehrtUebernehmen(antwort.version, ergebnis.db, lokalStand);
        etikettenNacharbeit(ergebnis.db);
        return { zusammengefuehrt: ergebnis, version: antwort.version };
      }
      /* Ein drittes Gerät war schneller. Die Basis bleibt dieselbe —
         sie ist der gemeinsame Ausgangspunkt —, nur der Serverstand ist
         neu. Einmal nachfassen, dann fragen. */
      if (versuch < 1) {
        return nachVersionskonflikt(antwort.version, antwort.daten, lokalStand,
          { dialog, beiKonflikt, versuch: versuch + 1, basis: ausgang });
      }
      const frisch = migriere(antwort.daten);
      return zeigeKonflikt(antwort.version, frisch, ausgang,
        fuehreDreiWegeZusammen(ausgang, lokalStand, frisch), dialog);
    }
    return zeigeKonflikt(serverVersion, serverDaten, ausgang, ergebnis, dialog);
  };

  /* Bis zur Entscheidung schreibt der Client nicht weiter gegen den
     Server; lokal wird weiterhin gesichert. */
  const zeigeKonflikt = (serverVersion, serverDaten, basis, ergebnis, dialog) => {
    offenerKonflikt.current = { version: serverVersion, daten: serverDaten };
    setSync({ status: "konflikt", version: serverVersion });
    setSyncLauf({ phase: "konflikt", serverVersion, serverDaten, basis, ergebnis });
    if (dialog) setModal((m) => m || { typ: "sync" });
    return { konflikt: true };
  };


  /* ── Etiketten: Nachtrag und Vorrat ───────────────────────────
     Nach jedem erfolgreichen Kontakt zum Server: erst die ohne Netz
     aufgenommenen Fotos nachreichen (sie zeigen bis dahin auf einen
     Platzhalterpfad), dann die Vorschaubilder auffüllen und alte
     wegräumen. Läuft absichtlich nach dem Abgleich und nicht
     währenddessen — Bilder sind Beiwerk, der Kellerbuchstand nicht. */
  const etikettenLaeuft = useRef(false);
  /* Der Etikettenlauf läuft außerhalb des Renders; er braucht die
     Einstellung als Ref, nicht als eingefrorene Kopie. */
  const kritikPrefsRef = useRef({ geteilt: true });
  /* Wartende Fotos gehören sichtbar ins Menü: Beim Abmelden wird die
     Warteschlange geleert, damit auf einem geteilten Gerät nichts vom
     Vorbesitzer liegen bleibt — wer das nicht weiß, verlöre die
     Aufnahmen wortlos. */
  const [wartendeFotos, setWartendeFotos] = useState(0);
  const zaehleWartende = () => { fotoWarteschlangeAnzahl().then(setWartendeFotos).catch(() => {}); };

  const etikettenNacharbeit = async (standFuerVorrat) => {
    if (etikettenLaeuft.current) return { gesendet: 0, offen: 0 };
    etikettenLaeuft.current = true;
    /* Der Vorrat läuft im Hintergrund weiter und gibt die Sperre erst
       dann frei — sonst starteten mehrere Ladeläufe nebeneinander. */
    let sofortFreigeben = true;
    try {
      const erledigt = await fotoWarteschlangeSenden();
      if (erledigt.length > 0) setDb((prev) => ersetzeWartendeFotos(prev, erledigt));
      const stand = standFuerVorrat || db;
      /* Geteilte Kritiken mit hochschieben. Kein eigener Anlauf: Wer
         hier ist, hat gerade Kontakt zum Server. Ein Fehlschlag darf
         den Etikettenlauf nicht abbrechen — beim nächsten Abgleich
         wieder. */
      if (katalogAktiv) {
        kritikenTeilen(stand || db, kritikPrefsRef.current.geteilt).catch(() => {});
      }
      const offen = (await fehlendeEtiketten(stand)).length;
      if (offen > 0) {
        sofortFreigeben = false;
        etikettenVorladen(stand)
          .then(() => etikettenAufraeumen(stand))
          .catch(() => {})
          .then(() => { etikettenLaeuft.current = false; });
      } else {
        etikettenAufraeumen(stand).catch(() => {});
      }
      zaehleWartende();
      return { gesendet: erledigt.length, offen };
    } catch (e) {
      zaehleWartende();
      return { gesendet: 0, offen: 0 };
    } finally {
      if (sofortFreigeben) etikettenLaeuft.current = false;
    }
  };


  /* ── Menüpunkt „Daten synchronisieren" ─────────────────────────
     Ein Abgleich in beide Richtungen. Der Ablauf ist bewusst
     sparsam: erst nur die Versionsnummer (wenige Bytes), der volle
     Serverstand nur dann, wenn er tatsächlich gebraucht wird —
     also beim Herunterladen und beim Konflikt.

     `lauf` beschreibt den Zustand des Dialogs, nicht den der App;
     der eigentliche Datenzustand bleibt in `db`/`sync`. */
  const [syncLauf, setSyncLauf] = useState(null);

  /* Nach dem Kellerbuch: Etiketten und Katalog. Beides ist Beiwerk —
     ein Fehlschlag hier ändert den Ausgang des Abgleichs nicht, er
     steht nur als eigene Zeile im Dialog. `basis` ist der frisch
     übernommene Stand, wenn heruntergeladen wurde. */
  const nacharbeit = async (phase, stand, basis = null) => {
    setSyncLauf((l) => (l && l.phase === phase
      ? { ...l, etiketten: "laeuft", katalog: katalogAktiv ? "laeuft" : null } : l));
    const [et, kat] = await Promise.all([etikettenNacharbeit(stand), katalogAbgleich(basis)]);
    setSyncLauf((l) => (l && l.phase === phase ? { ...l, etiketten: et, katalog: kat } : l));
  };

  const synchronisieren = async () => {
    const serialisiert = serialisiere(db);
    const lokalGeaendert = !!db && serialisiert !== zuletztGespeichert.current;

    setModal({ typ: "sync" });
    setSyncLauf({ phase: "laeuft" });
    setSync((z) => ({ ...z, status: "pruefe" }));

    try {
      const serverVersion = await apiVersion();
      const fall = syncFall({
        lokalGeaendert,
        basisVersion: versionRef.current,
        serverVersion,
        /* Version 0 heißt: der Server hat noch nie einen Stand
           bekommen (siehe kern/sync.js). */
        serverHatStand: (serverVersion || 0) > 0,
        lokalHatDaten: !!db,
      });

      if (fall === "aktuell") {
        setSync({ status: "aktuell", version: serverVersion });
        setSyncLauf({ phase: "aktuell", version: serverVersion });
        await nacharbeit("aktuell", db);
        return;
      }

      if (fall === "hochladen") {
        const antwort = await apiSpeichern(versionRef.current, db);
        if (antwort.konflikt) {
          /* Zwischen Versionsabfrage und Schreiben hat ein anderes
             Gerät gespeichert — dann wie beim Konflikt. */
          await konfliktImDialog(antwort.version, antwort.daten);
          return;
        }
        uebernehmeLokalenStand(antwort.version, db, serialisiert);
        setSyncLauf({ phase: "hochgeladen", version: antwort.version });
        await nacharbeit("hochgeladen", db);
        return;
      }

      const stand = await apiLaden();

      if (fall === "herunterladen") {
        const neuerStand = stand.daten ? uebernehmeServerStand(stand.version, stand.daten) : db;
        setSyncLauf({ phase: "heruntergeladen", version: stand.version });
        await nacharbeit("heruntergeladen", neuerStand, neuerStand);
        return;
      }

      /* konflikt: beide Seiten geändert. Erst zusammenführen; nur bei
         echten Widersprüchen entscheidet der Nutzer. */
      await konfliktImDialog(stand.version, stand.daten);
    } catch (e) {
      if (e && e.status === 401) { setModal(null); setSyncLauf(null); sitzungVerloren(); return; }
      if (e && e.status) {
        /* Der Server hat geantwortet, aber abgelehnt (etwa 413: zu
           groß). Das ist kein „offline“ — es wird nicht von selbst
           besser. */
        setSync({ status: "fehler", version: versionRef.current, text: e.message });
        setSyncLauf({ phase: "fehler", text: e.message });
        return;
      }
      /* Kein Status = die Anfrage kam gar nicht durch. */
      setSync({ status: "offline", version: versionRef.current });
      setSyncLauf({ phase: "offline" });
    }
  };

  /* Beide Seiten geändert, der Dialog ist offen: zusammenführen und
     den Ausgang dort zeigen. */
  const konfliktImDialog = async (serverVersion, serverDaten, optionen = {}) => {
    const erg = await nachVersionskonflikt(serverVersion, serverDaten, db, { dialog: false, ...optionen });
    if (!erg.zusammengefuehrt) return;
    const z = erg.zusammengefuehrt;
    setSyncLauf({
      phase: "zusammengefuehrt", version: erg.version,
      vonHier: z.vonHier, vomServer: z.vomServer,
      aufgeloest: optionen.beiKonflikt ? z.konflikte.length : 0, seite: optionen.beiKonflikt || null,
    });
    await nacharbeit("zusammengefuehrt", z.db);
  };

  /* Konfliktausgang „Zusammenführen“ — Widersprüche zugunsten der
     gewählten Seite, alles andere ohnehin zusammen. */
  const konfliktZusammenfuehren = async (seite) => {
    if (!syncLauf || syncLauf.phase !== "konflikt" || !syncLauf.basis) return;
    try {
      await konfliktImDialog(syncLauf.serverVersion, syncLauf.serverDaten, { beiKonflikt: seite, basis: syncLauf.basis });
    } catch (e) {
      if (e && e.status === 401) { setModal(null); setSyncLauf(null); sitzungVerloren(); return; }
      setSync(e && e.status
        ? { status: "fehler", version: versionRef.current, text: e.message }
        : { status: "offline", version: versionRef.current });
      setSyncLauf({ phase: e && e.status ? "fehler" : "offline", text: e && e.message });
    }
  };

  /* Konfliktausgang „Dieses Gerät behalten": mit der aktuellen
     Serverversion als Basis schreiben, damit die optimistische Sperre
     durchlässt. Das ist die bewusste Entscheidung des Nutzers, den
     Serverstand zu überschreiben. */
  const konfliktLokalBehalten = async () => {
    if (!syncLauf || syncLauf.phase !== "konflikt") return;
    const serialisiert = serialisiere(db);
    try {
      const antwort = await apiSpeichern(syncLauf.serverVersion, db);
      if (antwort.konflikt) {
        const frisch = migriere(antwort.daten);
        zeigeKonflikt(antwort.version, frisch, syncLauf.basis || null,
          syncLauf.basis ? fuehreDreiWegeZusammen(syncLauf.basis, db, frisch) : null, false);
        return;
      }
      uebernehmeLokalenStand(antwort.version, db, serialisiert);
      setSyncLauf({ phase: "hochgeladen", version: antwort.version });
      await nacharbeit("hochgeladen", db);
    } catch (e) {
      if (e && e.status === 401) { setModal(null); setSyncLauf(null); sitzungVerloren(); return; }
      setSync(e && e.status
        ? { status: "fehler", version: versionRef.current, text: e.message }
        : { status: "offline", version: versionRef.current });
      setSyncLauf({ phase: e && e.status ? "fehler" : "offline", text: e && e.message });
    }
  };

  /* Konfliktausgang „Server behalten": der lokale Stand wird
     verworfen. Der Serverstand liegt bereits vor, es braucht keinen
     weiteren Abruf. */
  const konfliktServerBehalten = async () => {
    if (!syncLauf || syncLauf.phase !== "konflikt") return;
    const neuerStand = uebernehmeServerStand(syncLauf.serverVersion, syncLauf.serverDaten);
    setSyncLauf({ phase: "heruntergeladen", version: syncLauf.serverVersion });
    await nacharbeit("heruntergeladen", neuerStand, neuerStand);
  };

  /* Start: lokale Kopie sofort anzeigen, dann nur die Versionsnummer
     prüfen — der volle Stand wird ausschließlich bei einem Update
     geladen. Ohne lokale Kopie wird einmalig komplett geladen. */
  useEffect(() => {
    if (!nutzer) return;
    let aktiv = true;
    (async () => {
      /* Lokale Kopie und Wetterteil liegen in IndexedDB — beides wird
         vor dem ersten Bild geladen (wenige Millisekunden). */
      const [lokal, wetter] = await Promise.all([ladeLokal(nutzer.benutzername), ladeWetter(nutzer.benutzername)]);
      if (!aktiv) return;
      wetterRef.current = wetter;
      if (lokal && lokal.daten) {
        /* Ältere Kopien tragen den Wetterteil noch in sich; der
           getrennt abgelegte geht vor. */
        const d = mitWetter(migriere(lokal.daten), wetter);
        versionRef.current = lokal.version || 0;
        merkeStand((lokal.ungesichert || migrationVeraendert(lokal.daten, d))
          ? null : serialisiere(d));
        /* Basis für ein späteres Zusammenführen: Ist die lokale Kopie
           bestätigt, ist sie selbst die Basis. Sonst die abgelegte —
           aber nur, wenn sie zur selben Serverversion gehört, auf der
           die Kopie aufsetzt. Geladen wird VOR dem ersten Schreib-
           versuch, denn genau der stößt bei 409 das Zusammenführen an. */
        if (!lokal.ungesichert) {
          basisRef.current = { version: lokal.version || 0, daten: ohneWetter(d) };
        } else {
          const b = await ladeBasis(nutzer.benutzername);
          basisRef.current = b && b.version === (lokal.version || 0) ? { version: b.version, daten: migriere(b.daten) } : null;
        }
        if (!aktiv) return;
        setDb(d);
        setSync({ status: "pruefe", version: lokal.version || 0 });
        try {
          const serverVersion = await apiVersion();
          if (!aktiv) return;
          if (serverVersion === (lokal.version || 0)) {
            /* Gleiche Version. Gab es lokal ungesicherte Änderungen,
               schiebt der Speichereffekt sie gleich hinauf. */
            setSync({ status: "aktuell", version: versionRef.current });
          } else if (!lokal.ungesichert) {
            const stand = await apiLaden();
            if (!aktiv) return;
            uebernehmeServerStand(stand.version, stand.daten);
          } else {
            /* Beide Seiten sind weitergelaufen. Der erste Schreibversuch
               des Speichereffekts bekommt 409 und führt dann zusammen —
               oder fragt, wenn es echte Widersprüche gibt. */
            setSync({ status: "konflikt", version: versionRef.current });
          }
        } catch (e) {
          if (!aktiv) return;
          if (e && e.status === 401) { sitzungVerloren(); return; }
          /* Ohne Netz wird mit der lokalen Kopie weitergearbeitet. */
          setSync({ status: "offline", version: versionRef.current });
        }
        return;
      }
      /* Kein lokaler Stand vorhanden */
      try {
        const stand = await apiLaden();
        if (!aktiv) return;
        if (stand.daten) {
          uebernehmeServerStand(stand.version, stand.daten);
        } else {
          /* Leere Datenbank: mit Stammdaten beginnen; der Speicher-
             effekt legt den Anfangsstand automatisch auf dem Server ab. */
          const d = mitWetter(migriere(SEED), wetter);
          versionRef.current = stand.version || 0;
          merkeStand(null);
          setDb(d);
          setSync({ status: "aktuell", version: stand.version || 0 });
        }
      } catch (e) {
        if (!aktiv) return;
        if (e && e.status === 401) { sitzungVerloren(); return; }
        setDb(migriere(SEED));
        setSync({ status: "offline", version: 0 });
      }
    })();
    return () => { aktiv = false; };
  }, [nutzer]);

  /* Etikettenvorrat auffüllen, sobald ein Stand da ist und der Server
     antwortet. Als eigener Effekt und nicht im Startpfad, weil es drei
     Wege in die Anwendung gibt (lokale Kopie, Serverstand, frisches
     Konto) und der Vorrat auf jedem davon gebraucht wird. Verzögert,
     damit der erste Bildaufbau Vorrang hat. */
  useEffect(() => {
    if (!db || !nutzer) return;
    if (sync && (sync.status === "offline" || sync.status === "konflikt")) return;
    zaehleWartende();
    const t = setTimeout(() => { etikettenNacharbeit(db); }, 1500);
    return () => clearTimeout(t);
  }, [nutzer, !!db, sync ? sync.status : null]);


  /* Entprelltes Speichern: nur bei tatsächlicher Änderung schreiben,
     mit optimistischer Sperre.

     Drei Dinge sind hier wichtig:
     1. Die lokale Kopie wird IMMER zuerst geschrieben, noch vor dem
        Netzversuch. Ohne Netz — und beim Schließen des Tabs mitten im
        Versuch — ist damit trotzdem nichts verloren.
     2. Bei 409 wird zusammengeführt (`nachVersionskonflikt`); nur echte
        Widersprüche gehen an den Nutzer, und bis zu seiner Entscheidung
        wird nicht weiter gegen den Server geschrieben.
     3. Es schreibt immer nur ein Vorgang. Kommt währenddessen ein
        weiterer Anlass (der Nutzer tippt, das Netz ist wieder da),
        wird danach mit dem dann neuesten Stand nachgelegt — sonst
        überholten sich zwei Schreibversuche mit derselben Basisversion
        und erzeugten einen Konflikt mit sich selbst. */
  const schreibtGerade = useRef(false);
  const nochmalSchreiben = useRef(false);

  const schreibeStand = async (stand) => {
    if (!stand || !nutzer) return;
    if (schreibtGerade.current) { nochmalSchreiben.current = true; return; }
    const serialisiert = serialisiere(stand);
    if (serialisiert === zuletztGespeichert.current) return;
    lokalAblegen({ version: versionRef.current, daten: stand, ungesichert: true }, serialisiert);
    setUngesichert(true);
    if (offenerKonflikt.current) return; /* wartet auf Entscheidung */
    schreibtGerade.current = true;
    setSync((s) => ({ ...s, status: "speichert" }));
    try {
      const antwort = await apiSpeichern(versionRef.current, stand);
      if (antwort.konflikt) {
        await nachVersionskonflikt(antwort.version, antwort.daten, stand, { dialog: true });
        return;
      }
      uebernehmeLokalenStand(antwort.version, stand, serialisiert);
      /* Der Server ist erreichbar — guter Zeitpunkt, wartende Fotos
         nachzureichen und den Etikettenvorrat aufzufüllen. */
      etikettenNacharbeit(stand);
    } catch (e) {
      if (e && e.status === 401) { sitzungVerloren(); return; }
      /* Antwortet der Server mit einem Fehler (413 zu groß, 500), ist
         das kein „offline“ — lokal bleibt alles gesichert, aber der
         Nutzer muss es sehen. */
      setSync((s) => (e && e.status
        ? { ...s, status: "fehler", text: e.message }
        : { ...s, status: "offline" }));
    } finally {
      schreibtGerade.current = false;
      if (nochmalSchreiben.current) {
        nochmalSchreiben.current = false;
        /* Neuester Stand aus dem Ref, nicht der dieses Durchgangs. */
        setTimeout(() => schreibeStandRef.current(dbRef.current), 0);
      }
    }
  };
  const schreibeStandRef = useRef(schreibeStand);
  schreibeStandRef.current = schreibeStand;

  useEffect(() => {
    if (!db || !nutzer) return;
    if (serialisiere(db) === zuletztGespeichert.current) return;
    const t = setTimeout(() => { schreibeStand(db); }, 800);
    return () => clearTimeout(t);
  }, [db, nutzer]);

  /* Wetterteil getrennt ablegen, sobald er sich ändert (Abruf in der
     Witterung, „Wetterdaten laden“). Er geht nicht zum Server. */
  const wetterW = db ? db.weatherCache : null;
  const wetterK = db ? db.klimaCache : null;
  useEffect(() => {
    if (!db || !nutzer) return;
    const teil = wetterTeil(db);
    const bekannt = wetterRef.current;
    const gleicherTeil = (a, b) => a === b || (Object.keys(a || {}).length === 0 && Object.keys(b || {}).length === 0);
    if (bekannt && gleicherTeil(bekannt.weatherCache, teil.weatherCache) && gleicherTeil(bekannt.klimaCache, teil.klimaCache)) return;
    const t = setTimeout(() => {
      wetterRef.current = teil;
      speichereWetter(nutzer.benutzername, teil);
    }, 1000);
    return () => clearTimeout(t);
  }, [wetterW, wetterK, nutzer]);

  /* Detailnavigation legt auf den Verlauf; die Top-Navigation setzt
     ihn zurück, da ihre Ziele oberste Ebenen sind. */
  const geheZu = (r) => { setVerlauf((v) => [...v, r]); window.scrollTo({ top: 0 }); };
  const springeZu = (r) => { setVerlauf([r]); window.scrollTo({ top: 0 }); };
  const zurueck = () => { setVerlauf((v) => v.length > 1 ? v.slice(0, -1) : v); window.scrollTo({ top: 0 }); };
  const oeffneModal = (m) => setModal(m);
  /* Schließt den Dialog — oder kehrt zu dem zurück, aus dem heraus er
     geöffnet wurde (modal.zurueck). Nur so bleibt man beim Bearbeiten
     einer Bewegung aus dem Trinkverlauf heraus in der Liste. */
  const schliesseModal = () => setModal((m) => (m && m.zurueck) ? m.zurueck : null);
  /* Der Sync-Dialog trägt einen eigenen Lauf-Zustand, der mit dem
     Fenster verschwindet. Ein ungelöster Konflikt bleibt erhalten —
     er steckt in offenerKonflikt und in sync.status. */
  const schliesseSync = () => { setSyncLauf(null); setModal(null); };

  /* Geteilte, persistierte Anzeigeeinstellung */
  /* Katalog: im Cloud-Modus einmal je Sitzung geladen. */
  const [katalog, setKatalog] = useState(null);
  const [katalogLaedt, setKatalogLaedt] = useState(false);
  const [katalogVersuch, setKatalogVersuch] = useState(0);
  useSprache();
  /* Sprache des Kontos übernehmen; bei neuen Konten schlägt der
     Browser vor. */
  useEffect(() => {
    if (!nutzer) return;
    setzeSprache(IST_SPRACHE(nutzer.sprache) ? nutzer.sprache : browserSprache());
  }, [nutzer && nutzer.sprache, nutzer && nutzer.benutzername]);

  const spracheWechseln = async (code) => {
    await setzeSprache(code);
    setNutzer((n) => (n ? { ...n, sprache: code } : n));
    try {
      await fetch("/api/konto/sprache", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sprache: code }),
      });
    } catch (e) { /* Anzeige ist bereits umgestellt */ }
  };

  const istCloud = !!nutzer && nutzer.modus !== "lokal";
  /* Vom Admin gesperrte Konten nehmen am Katalog nicht teil — weder
     lesend noch schreibend. Ihre eigenen Daten bleiben unberührt. */
  const katalogGesperrt = !!nutzer && nutzer.darfKatalog === false;
  const istKurator = !!nutzer && nutzer.istGlobal === true;
  const katalogAktiv = istCloud && !katalogGesperrt;

  /* Kuratorenkonten sehen den gesamten Katalog. Bewusst nur als
     Anzeigesicht: `db` bleibt das eigene Kellerbuch, sonst würde der
     Katalog mitgespeichert und für jedes Objekt ein Vorschlag
     entstehen. */
  /* „Mein Keller“ oder „Alle“ — gilt für Keller, Weine und Winzer
     gemeinsam. Kuratorenkonten sehen immer alles; für sie ist der
     Katalog der Arbeitsgegenstand. */
  const [geteilteKritiken, setGeteilteKritiken] = useState(null);

  /* `sicht` ersetzt die frühere Kombination aus `quelle` und
     `nurBestand`. Letzteres liegt weiterhin im Kellerbuch (prefs) —
     es ist eine Einstellung des Nutzers und soll geräteübergreifend
     gelten; die Sicht wird daraus abgeleitet und wieder dorthin
     zurückgeschrieben. */
  const [nurKatalogSicht, setNurKatalogSicht] = usePersistentState("ansicht.alle", false);
  const zeigeAlle = istKurator || (nurKatalogSicht && katalogAktiv);


  const sichtDb = useMemo(
    () => (zeigeAlle && katalog ? mischeKatalog(db, katalog) : db),
    [zeigeAlle, katalog, db]);

  /* Fremde Kritiken einmal je Sitzung holen — auch im eigenen Keller,
     denn dort bietet die Weinansicht sie unter „Alle Kritiken
     einblenden“ an. Ein Fehlschlag wird als leere Liste vermerkt und
     nicht wiederholt. */
  useEffect(() => {
    if (!katalogAktiv || geteilteKritiken !== null) return;
    let aktiv = true;
    (async () => {
      try {
        const r = await fetch("/api/kritiken");
        if (!r.ok) throw new Error("nicht verfügbar");
        const j = await r.json();
        if (aktiv) setGeteilteKritiken(j.kritiken || []);
      } catch (e) {
        if (aktiv) setGeteilteKritiken([]);   /* nicht erneut versuchen */
      }
    })();
    return () => { aktiv = false; };
  }, [katalogAktiv, geteilteKritiken]);

  useEffect(() => {
    if (!nutzer || !katalogAktiv) { setKatalog(null); setKatalogLaedt(false); return; }
    if (katalog) return;                     /* schon da */
    let aktiv = true;
    setKatalogLaedt(true);
    (async () => {
      try {
        const stand = await katalogLaden();
        if (aktiv && stand) { setKatalog(stand.daten); katalogVersionRef.current = stand.version; }
      } catch (e) {
        /* Ohne Katalog bleibt alles wie bisher bedienbar. Der Versuch
           wird aber nicht vergessen: `katalogVersuch` zählt hoch,
           sobald der Nutzer die Sicht „Alle Weine“ wählt — sonst
           bliebe sie nach einem einzigen Fehlschlag für die ganze
           Sitzung leer. */
      } finally {
        if (aktiv) setKatalogLaedt(false);
      }
    })();
    return () => { aktiv = false; };
  }, [nutzer && nutzer.benutzername, katalogAktiv, katalogVersuch]);

  /* Beim Umschalten auf „Alle Weine“ nachfassen, falls der Katalog
     noch fehlt — er wird beim Start nebenher geladen und kann bei
     einem schnellen Griff ins Menü noch unterwegs sein. Genau daher
     kam „erst nach erneutem Laden sichtbar“. */
  useEffect(() => {
    if (zeigeAlle && katalogAktiv && !katalog && !katalogLaedt) {
      setKatalogVersuch((n) => n + 1);
    }
  }, [zeigeAlle, katalogAktiv, katalog, katalogLaedt]);

  /* ── Katalogabgleich ──────────────────────────────────────────
     Katalog, Protokoll und eigene Vorschläge gehören zusammen und
     laufen deshalb als EIN Abgleich: beim Start, sobald der Kellerbuch-
     stand feststeht, und bei jedem „Daten synchronisieren“. Vorher
     geschah das genau einmal je Sitzung beim Start — eine Entscheidung
     des Admins oder eine Katalogänderung kam erst nach dem nächsten
     Neuladen an, und der Katalog selbst wurde nie aufgefrischt.

     Reihenfolge: Katalog → Vorschläge → Protokoll → fällige Vorschläge.
     Das Protokoll muss VOR dem Senden verarbeitet sein: Sonst sähe der
     Abgleich eine Katalogänderung, die das eigene Kellerbuch noch nicht
     kennt, als eigene Abweichung — und schlüge dem Admin vor, sie
     zurückzunehmen. `protokollStandRef` hält fest, bis zu welcher
     Katalogversion verarbeitet ist; gesendet wird nur, wenn das den
     geladenen Katalog abdeckt. */
  const katalogVersionRef = useRef(null);
  const protokollStandRef = useRef(-1);
  const dbRef = useRef(db);
  dbRef.current = db;
  const katalogRef = useRef(katalog);
  katalogRef.current = katalog;

  const [historie, setHistorie] = useState([]);
  const [katalogVorschlaege, setKatalogVorschlaege] = useState([]);
  const [adminOffen, setAdminOffen] = useState(0);
  const katalogStartGelaufen = useRef(false);
  const katalogAbgleichLaeuft = useRef(false);
  const katalogZuletzt = useRef(0);
  const sendetVorschlaege = useRef(false);
  const katalogNachfassen = useRef(false);
  const gemeldeteEntscheidungen = useRef(new Set());

  /* Bis wann kennt der Nutzer die Entscheidungen über seine Vorschläge?
     Je Gerät im localStorage — eine Lesemarke, keine Fachangabe. Ohne
     gespeicherten Wert gilt „jetzt“: Alte Entscheidungen sind nicht neu. */
  const gesehenSchluessel = nutzer ? `winelake:vorschlaege-gesehen:${nutzer.benutzername}` : null;
  const [vorschlaegeGesehen, setVorschlaegeGesehen] = useState(null);
  useEffect(() => {
    if (!gesehenSchluessel) { setVorschlaegeGesehen(null); return; }
    let wert = null;
    try { wert = localStorage.getItem(gesehenSchluessel); } catch (e) { /* privater Modus */ }
    if (!wert) {
      wert = new Date().toISOString();
      try { localStorage.setItem(gesehenSchluessel, wert); } catch (e) {}
    }
    setVorschlaegeGesehen(wert);
  }, [gesehenSchluessel]);
  const vorschlaegeGesehenMerken = () => {
    const jetzt = new Date().toISOString();
    try { if (gesehenSchluessel) localStorage.setItem(gesehenSchluessel, jetzt); } catch (e) {}
    setVorschlaegeGesehen(jetzt);
  };
  const neuEntschieden = vorschlaegeGesehen
    ? katalogVorschlaege.filter((v) => v.status !== "offen" && String(v.entschieden || "") > vorschlaegeGesehen).length
    : 0;

  const vorschlaegeAktualisieren = async () => {
    try {
      const vs = await vorschlaegeHolen();
      setKatalogVorschlaege(vs);
      return vs;
    } catch (e) { return null; /* nicht kritisch */ }
  };

  /* Fällige Vorschläge senden. Ein Lauf zur Zeit — Abgleich und
     Speichereffekt dürfen sonst dasselbe doppelt schicken. */
  const faelligeSenden = async (stand, kat, vs) => {
    if (sendetVorschlaege.current || !stand || !kat) return { gesendet: 0, selbst: 0 };
    if (protokollStandRef.current < (katalogVersionRef.current || 0)) return { gesendet: 0, selbst: 0 };
    sendetVorschlaege.current = true;
    let gesendet = 0;
    let selbst = 0;
    try {
      /* Gesperrt sind Dublettenfragen und offene Abweichungen: Solange
         der Nutzer nicht entschieden hat, ob er die Katalogfassung
         übernimmt, wäre seine eigene noch kein Vorschlag. */
      const gesperrt = new Set([
        ...gesperrteIds(stand, kat),
        ...offeneAbweichungen(stand).map((a) => a.objektId),
      ]);
      const faellig = offeneVorschlaege(stand, kat, vs, gesperrt);
      /* Eine Sendung statt bis zu 50 Einzelanfragen — der Server
         schreibt sie in einem Zug. Der Rest folgt im nächsten Lauf,
         den die aktualisierte Vorschlagsliste ohnehin anstößt. */
      if (faellig.length > 0) {
        try {
          const erg = await vorschlaegeSenden(faellig.slice(0, 50));
          gesendet = erg.gesendet;
          selbst = erg.angenommen;
        } catch (e) { /* nächster Lauf */ }
      }
      if (gesendet > 0) await vorschlaegeAktualisieren();
      /* Vorschläge des Admins sind schon im Katalog. Katalog und
         Protokoll gleich nachziehen, sonst stünde das bis zum nächsten
         Abgleich als „in Prüfung“ da. */
      if (selbst > 0) katalogNachfassen.current = true;
    } finally {
      sendetVorschlaege.current = false;
    }
    if (katalogNachfassen.current && !katalogAbgleichLaeuft.current) {
      katalogNachfassen.current = false;
      setTimeout(() => katalogAbgleichRef.current(), 300);
    }
    return { gesendet: Math.max(0, gesendet - selbst), selbst };
  };

  /** Liefert einen Bericht für den Sync-Dialog, `null` wenn nichts zu
      tun war (kein Katalog im Spiel), oder `{ fehler: true }`.
      `basis` übersteuert den Stand, auf dem gearbeitet wird — nach
      dem Herunterladen ist `db` im Ref noch der alte. */
  const katalogAbgleich = async (basis = null) => {
    if (!katalogAktiv || katalogAbgleichLaeuft.current) return null;
    const ausgang = basis || dbRef.current;
    if (!ausgang) return null;
    katalogAbgleichLaeuft.current = true;
    katalogZuletzt.current = Date.now();
    const bericht = { eingespielt: 0, abweichend: 0, zusammengefuehrt: 0, angenommen: 0, abgelehnt: 0, gesendet: 0 };
    try {
      let kat = katalogRef.current;
      const stand = await katalogLaden(kat ? katalogVersionRef.current : null);
      if (stand) { kat = stand.daten; katalogVersionRef.current = stand.version; setKatalog(stand.daten); }

      const vs = await vorschlaegeHolen();
      setKatalogVorschlaege(vs);
      /* Gemeldet wird jede Entscheidung einmal je Sitzung — die
         dauerhafte Marke „neu“ im Menü bleibt, bis der Nutzer die
         Liste geöffnet hat. */
      for (const v of vs) {
        if (v.status === "offen" || gemeldeteEntscheidungen.current.has(v.id)) continue;
        if (vorschlaegeGesehen && String(v.entschieden || "") > vorschlaegeGesehen) {
          bericht[v.status] = (bericht[v.status] || 0) + 1;
          gemeldeteEntscheidungen.current.add(v.id);
        }
      }

      const { version, eintraege, luecke } = await protokollHolen(ausgang.katalogGesehen != null ? ausgang.katalogGesehen : -1);
      let nachProtokoll = ausgang;
      /* Fehlt ein Stück Protokoll (gekappt), wird nach dem Einspielen
         des Vorhandenen jedes eigene Katalogobjekt, das noch abweicht,
         zur offenen Abweichung — statt als Vorschlag hinauszugehen
         (dienste/historie.js, `lueckenErgebnisse`). */
      const auswerten = (stand) => {
        const r = eintraege && eintraege.length > 0
          ? verarbeiteProtokoll(stand, eintraege, { eigeneVorschlaege: vs })
          : { db: stand, ergebnisse: [] };
        const zusatz = luecke && kat ? lueckenErgebnisse(r.db, kat, { eigeneVorschlaege: vs }) : [];
        return { db: merkeAbweichungen({ ...r.db, katalogGesehen: version }, [...r.ergebnisse, ...zusatz]), ergebnisse: r.ergebnisse, zusatz };
      };
      if ((eintraege && eintraege.length > 0) || luecke) {
        const erg = auswerten(ausgang);
        nachProtokoll = erg.db;
        for (const r of erg.ergebnisse) {
          if (r.ausgang === "eingespielt") bericht.eingespielt++;
          else if (r.ausgang === "konflikt") bericht.abweichend++;
          else if (r.ausgang === "zusammengefuehrt") bericht.zusammengefuehrt++;
        }
        bericht.abweichend += erg.zusatz.length;
        if (luecke) bericht.luecke = true;
        /* Läuft der Stand zwischendurch weiter (der Nutzer tippt), wird
           auf dem neuen Stand noch einmal ausgewertet — das ist
           idempotent, ein bereits eingespielter Eintrag ist dann
           „bereits aktuell“. */
        setDb((prev) => (prev === ausgang ? nachProtokoll : auswerten(prev).db));
        setHistorie((alt) => [...alt, ...erg.ergebnisse]);
      }
      protokollStandRef.current = version;

      const sendung = await faelligeSenden(nachProtokoll, kat, vs);
      bericht.gesendet = sendung.gesendet;
      bericht.selbst = sendung.selbst;

      if (nutzer && nutzer.istAdmin) {
        try {
          const r = await fetch("/api/admin/vorschlaege/anzahl");
          if (r.ok) setAdminOffen((await r.json()).offen || 0);
        } catch (e) { /* Marke ist Beiwerk */ }
      }
      return bericht;
    } catch (e) {
      if (e && e.status === 401) sitzungVerloren();
      return { fehler: true };
    } finally {
      katalogAbgleichLaeuft.current = false;
      if (katalogNachfassen.current) {
        katalogNachfassen.current = false;
        setTimeout(() => katalogAbgleichRef.current(), 300);
      }
    }
  };
  const katalogAbgleichRef = useRef(katalogAbgleich);
  katalogAbgleichRef.current = katalogAbgleich;

  /* Beim Start, sobald der Kellerbuchstand feststeht — nicht vorher,
     sonst würde das Protokoll in einen Stand eingespielt, den der
     Serverabgleich gleich danach ersetzt. */
  useEffect(() => {
    if (!db || !nutzer || !katalogAktiv || katalogStartGelaufen.current) return;
    if (!sync || sync.status !== "aktuell") return;
    katalogStartGelaufen.current = true;
    katalogAbgleich();
  }, [!!db, nutzer && nutzer.benutzername, katalogAktiv, sync && sync.status]);

  useEffect(() => {
    if (!nutzer || !katalogAktiv) setKatalogVorschlaege([]);
  }, [nutzer && nutzer.benutzername, katalogAktiv]);

  const abweichungen = useMemo(() => (db ? offeneAbweichungen(db) : []), [db]);

  /* Namen zu Kennungen — für die Anzeige von Unterschieden. Eigene
     Objekte gehen vor, der Katalog füllt auf. */
  const namenKarte = useMemo(() => {
    const namen = {};
    /* Eigene Vorschläge zuerst: Ein vorgeschlagener Winzer kann im
       eigenen Kellerbuch schon anders heißen oder gelöscht sein. */
    for (const v of katalogVorschlaege) if (v.nachher && v.nachher.name) namen[v.objektId] = v.nachher.name;
    if (katalog) {
      for (const o of [...(katalog.regionen || []), ...(katalog.winzer || []), ...(katalog.weine || [])]) namen[o.id] = o.name;
    }
    if (db) {
      for (const o of [...(db.regions || []), ...(db.winzer || []), ...(db.weine || [])]) namen[o.id] = o.name;
    }
    return namen;
  }, [db, katalog, katalogVorschlaege]);

  const katalogObjekt = (typ, id) =>
    (katalog && (katalog[TYP_ZU_KATALOG[typ]] || []).find((o) => o.id === id)) || null;

  /* Weicht das eigene Objekt von der Katalogfassung ab? */
  const weichtAb = (v) => {
    const k = katalogObjekt(v.typ, v.objektId);
    const liste = db ? db[{ wein: "weine", winzer: "winzer", region: "regions" }[v.typ]] || [] : [];
    const eigen = liste.find((o) => o.id === v.objektId);
    return !!(k && eigen && !gleich(katalogForm(v.typ, eigen), katalogForm(v.typ, k)));
  };

  /* Zurückziehen: erst der Server, dann das Kellerbuch — scheitert der
     Server, bleibt alles wie es war. Danach steht das Objekt so, dass
     der Abgleich es nicht sofort erneut vorschlägt. */
  const vorschlagZurueckziehenKlick = async (v) => {
    await vorschlagZurueckziehen(v.id);
    if (v.art === "neu") setDb((prev) => alsLokalGefuehrt(prev, v.typ, v.objektId));
    else setDb((prev) => aufKatalogfassung(prev, v.typ, v.objektId, katalogObjekt(v.typ, v.objektId)));
    await vorschlaegeAktualisieren();
  };

  const katalogfassungWiederherstellen = (v) =>
    setDb((prev) => aufKatalogfassung(prev, v.typ, v.objektId, katalogObjekt(v.typ, v.objektId)));

  /* Lokal geführten Altbestand für den Katalog freigeben. Es fällt
     nur `herkunft` weg — den Rest erledigt der reguläre Abgleich
     weiter unten, samt Reihenfolge (Region, Winzer, Wein) und
     Begrenzung auf 50 Vorschläge je Durchlauf. */
  const altbestandFreigeben = () => {
    setDb((prev) => gibFrei(prev));
    schliesseModal();
  };

  /* Entscheidungen anwenden: angenommen → Katalogobjekt,
     Aufnahme abgelehnt → dauerhaft lokal (dienste/vorschlaege.js). */
  useEffect(() => {
    if (!db || katalogVorschlaege.length === 0) return;
    setDb((prev) => wendeEntscheidungenAn(prev, katalogVorschlaege));
  }, [katalogVorschlaege]);

  /* Abgleich: nach jeder Änderung prüfen, was dem Admin vorzulegen
     ist. Verzögert, damit nicht jeder Tastendruck etwas auslöst. */
  useEffect(() => {
    if (!db || !katalog || !katalogAktiv) return;
    const timer = setTimeout(() => { faelligeSenden(db, katalog, katalogVorschlaege); }, 2500);
    return () => clearTimeout(timer);
  }, [db, katalog, katalogAktiv, katalogVorschlaege]);

  /* ── Abgleich im Hintergrund ──────────────────────────────────
     Bisher lief der Abgleich nur beim Start, nach einer Änderung und
     über das Menü. Zwei Lücken: Ohne Netz gemachte Änderungen blieben
     liegen, bis man wieder etwas änderte — und eine tagelang offene
     App (auf dem Telefon der Normalfall) arbeitete auf einem alten
     Stand weiter und lief beim nächsten Speichern in einen Konflikt,
     der gar nicht hätte sein müssen.

     Jetzt wird still abgeglichen, wenn die App wieder sichtbar wird,
     wenn das Netz zurück ist und alle fünf Minuten, solange sie offen
     und sichtbar ist. Erst nur die Versionsnummer (wenige Bytes); den
     vollen Stand nur bei Bedarf. Höchstens alle 30 Sekunden — außer
     beim Wiederkehren des Netzes. Ein Katalogabgleich hängt sich an,
     wenn der letzte länger als fünf Minuten her ist. Läuft gerade der
     Sync-Dialog oder wartet ein Konflikt auf Entscheidung, bleibt es
     still. */
  const stillLaeuft = useRef(false);
  const stillZuletzt = useRef(0);

  const stillerAbgleich = async ({ sofort = false } = {}) => {
    const stand = dbRef.current;
    if (!nutzer || !stand || stillLaeuft.current || offenerKonflikt.current) return;
    if (modal && modal.typ === "sync") return;
    if (!sofort && Date.now() - stillZuletzt.current < 30000) return;
    stillLaeuft.current = true;
    stillZuletzt.current = Date.now();
    try {
      const serverVersion = await apiVersion();
      const aktuell = dbRef.current;
      const lokalGeaendert = serialisiere(aktuell) !== zuletztGespeichert.current;
      let kellerStand = aktuell;
      if (serverVersion === versionRef.current) {
        if (lokalGeaendert) await schreibeStand(aktuell);
        else setSync((z) => (z.status === "offline" || z.status === "fehler" ? { status: "aktuell", version: serverVersion } : z));
      } else if (!lokalGeaendert) {
        const st = await apiLaden();
        if (st.daten) kellerStand = uebernehmeServerStand(st.version, st.daten, aktuell);
      } else {
        const st = await apiLaden();
        await nachVersionskonflikt(st.version, st.daten, aktuell, { dialog: true });
      }
      if (katalogAktiv && !offenerKonflikt.current && Date.now() - katalogZuletzt.current > 5 * 60 * 1000) {
        katalogAbgleich(kellerStand !== aktuell ? kellerStand : null);
      }
    } catch (e) {
      if (e && e.status === 401) { sitzungVerloren(); return; }
      setSync((z) => ({ ...z, status: "offline" }));
    } finally {
      stillLaeuft.current = false;
    }
  };
  const stillRef = useRef(stillerAbgleich);
  stillRef.current = stillerAbgleich;

  useEffect(() => {
    if (!nutzer) return;
    const sichtbar = () => { if (document.visibilityState === "visible") stillRef.current(); };
    const wiederOnline = () => { stillRef.current({ sofort: true }); };
    document.addEventListener("visibilitychange", sichtbar);
    window.addEventListener("online", wiederOnline);
    const takt = setInterval(sichtbar, 5 * 60 * 1000);
    return () => {
      document.removeEventListener("visibilitychange", sichtbar);
      window.removeEventListener("online", wiederOnline);
      clearInterval(takt);
    };
  }, [nutzer && nutzer.benutzername]);

  const modusWechseln = async (modus) => {
    try {
      const r = await fetch("/api/konto/modus", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ modus }),
      });
      if (!r.ok) return;
      setNutzer((n) => (n ? { ...n, modus } : n));
    } catch (e) { /* Netzfehler: Modus bleibt wie er war */ }
  };

  /* Übernahme aus dem Katalog in das eigene Kellerbuch. */
  const ausKatalog = (art, objekt) => {
    if (!katalog) return;
    setDb((prev) => {
      const f = art === "wein" ? uebernehmeWein : art === "winzer" ? uebernehmeWinzer : uebernehmeRegion;
      /* Beim Wein kommen die Jahrgänge bewusst NICHT mit: welche davon
         im eigenen Keller liegen, weiß nur der Nutzer. Er legt sie in
         der Weinansicht selbst an — und kann dabei aus den Jahrgängen
         des Katalogs wählen. */
      const erg = art === "wein" ? f(prev, katalog, objekt.id, false) : f(prev, katalog, objekt.id);
      return erg.db;
    });
    schliesseModal();
    /* Nach der Übernahme direkt zum Wein — dort geht es mit den
       Jahrgängen weiter. */
    if (art === "wein") geheZu({ view: "wein", id: objekt.id });
  };

  /* Der Winzer aus dem Katalog wird hier noch NICHT übernommen —
     erst wenn der Wein tatsächlich gespeichert wird. Bis dahin merkt
     sich nur der Dialog die Wahl; ein Abbruch hinterlässt so keinen
     verwaisten Winzer im Kellerbuch. */
  const katalogWinzerNutzen = (winzerObjekt) => {
    if (!katalog) return;
    setModal((m) => (m ? {
      ...m,
      kontext: { ...(m.kontext || {}), winzerId: winzerObjekt.id, katalogWinzerId: winzerObjekt.id },
    } : m));
  };

  const nurBestand = db && db.prefs ? db.prefs.nurBestand : true;
  const setNurBestand = (v) =>
    setDb((prev) => ({ ...prev, prefs: { ...(prev.prefs || {}), nurBestand: v } }));

  /* `sicht` fasst zusammen, was vorher zwei Schalter waren: der Umfang
     der Listen von eng nach weit. `nurBestand` bleibt im Kellerbuch
     (prefs) — es ist eine Einstellung des Nutzers und soll
     geräteübergreifend gelten; `alle` dagegen ist eine Frage der
     Sitzung und liegt lokal. */
  const sicht = zeigeAlle ? "alle" : (nurBestand ? "bestand" : "keller");
  const setSicht = (wert) => {
    setNurKatalogSicht(wert === "alle");
    if (wert !== "alle") setNurBestand(wert === "bestand");
  };

  /* ── Bestandsbuchung je Flaschengröße ── */
  const bucheBestand = (weinId, jgId, groesse, delta) => {
    setDb((prev) => ({
      ...prev,
      weine: prev.weine.map((w) => w.id !== weinId ? w : {
        ...w,
        jahrgaenge: w.jahrgaenge.map((j) => {
          if (j.id !== jgId) return j;
          const bestaende = { ...(j.bestaende || {}) };
          bestaende[groesse] = Math.max(0, (bestaende[groesse] || 0) + delta);
          return { ...j, bestaende };
        }),
      }),
    }));
  };

  const speichernEntnahme = ({ groesse, menge }) => {
    const { weinId, jgId, jahr } = modal.kontext;
    bucheBestand(weinId, jgId, groesse, -menge);
    const datum = new Date().toISOString();
    const wein = db.weine.find((w) => w.id === weinId);
    const jg = jahrgangFuer(wein, jgId, jahr);
    const preis = jg && jg.preis != null ? jg.preis : null;
    /* Getrunkene Flaschen dauerhaft protokollieren (Statistik) und
       zusätzlich in der Bewegungshistorie festhalten. */
    /* Beide Protokolle teilen sich eine ID — so bleibt die Entnahme
       später eindeutig zuzuordnen (Bearbeiten/Löschen). */
    const eid = uid();
    setDb((prev) => ({
      ...prev,
      entnahmen: [
        ...(prev.entnahmen || []),
        { id: eid, weinId, jgId, jahr, groesse, menge, preis, datum },
      ],
      bewegungen: [
        ...(prev.bewegungen || []),
        { id: eid, art: "entnahme", weinId, jgId, jahr, groesse, menge, preis, datum },
      ],
    }));
    /* Direkt im Anschluss die Kritik zum entnommenen Jahrgang anbieten */
    setModal({ typ: "kritik", kontext: { weinId, jgId, jahr, nachEntnahme: true } });
    return null;
  };

  /* Findet die zu einer Entnahme-Bewegung gehörende Entnahme. Neue
     Einträge teilen sich die ID; für Altbestände wird über die
     Eckdaten gesucht. */
  const findeEntnahme = (liste, b) =>
    (liste || []).find((e) => e.id === b.id)
    || (liste || []).find((e) => e.weinId === b.weinId && e.jgId === b.jgId
      && e.groesse === b.groesse && e.menge === b.menge && e.datum === b.datum);

  /* Bestand eines Jahrgangs um mehrere Größen-Deltas fortschreiben —
     in EINEM Durchgang. Zwei getrennte Buchungen wären falsch: Die
     Begrenzung auf 0 würde beim Zwischenschritt zuschlagen, sobald die
     ursprüngliche Menge größer ist als der heutige Bestand (weil
     zwischenzeitlich entnommen wurde). Der Abzug ginge verloren und
     die neue Menge käme voll obendrauf. */
  const bucheDeltas = (prev, weinId, jgId, deltas) => prev.weine.map((w) => w.id !== weinId ? w : {
    ...w,
    jahrgaenge: w.jahrgaenge.map((j) => {
      if (j.id !== jgId) return j;
      const bestaende = { ...(j.bestaende || {}) };
      for (const [g, d] of deltas) bestaende[g] = Math.max(0, (bestaende[g] || 0) + d);
      return { ...j, bestaende };
    }),
  });

  const speichernBewegung = (werte) => {
    const alt = modal.objekt;
    const neuB = { ...alt, ...werte };
    setDb((prev) => {
      /* Alte Wirkung zurücknehmen und neue anwenden — zusammengefasst,
         damit sich beide bei gleicher Flaschengröße verrechnen. */
      const deltas = bestandsDeltas(alt, neuB);

      const entn = prev.entnahmen || [];
      const treffer = alt.art === "entnahme" ? findeEntnahme(entn, alt) : null;
      return {
        ...prev,
        weine: bucheDeltas(prev, alt.weinId, alt.jgId, deltas),
        bewegungen: (prev.bewegungen || []).map((b) => (b.id === alt.id && b.art === alt.art) ? neuB : b),
        entnahmen: treffer
          ? entn.map((e) => e.id === treffer.id ? { ...e, groesse: neuB.groesse, menge: neuB.menge, preis: neuB.preis, datum: neuB.datum } : e)
          : entn,
      };
    });
    schliesseModal();
    return null;
  };

  const loescheBewegung = (b) => {
    setDb((prev) => {
      const entn = prev.entnahmen || [];
      const treffer = b.art === "entnahme" ? findeEntnahme(entn, b) : null;
      return {
        ...prev,
        weine: bucheDeltas(prev, b.weinId, b.jgId, bestandsDeltas(b, null)),
        bewegungen: (prev.bewegungen || []).filter((x) => !(x.id === b.id && x.art === b.art)),
        entnahmen: treffer ? entn.filter((e) => e.id !== treffer.id) : entn,
      };
    });
    schliesseModal();
  };

  const speichernZugang = ({ groesse, menge, haendler, preis, datum }) => {
    const { weinId, jgId, jahr } = modal.kontext;
    bucheBestand(weinId, jgId, groesse, menge);
    const iso = datum ? new Date(datum).toISOString() : new Date().toISOString();
    setDb((prev) => ({
      ...prev,
      bewegungen: [
        ...(prev.bewegungen || []),
        { id: uid(), art: "zugang", weinId, jgId, jahr, groesse, menge, datum: iso,
          haendler: haendler || "", preis: preis != null ? preis : null },
      ],
    }));
    schliesseModal();
    return null;
  };

  /* ── Speichern (liefert Fehlertext oder null) ── */
  const speichernRegion = (werte) => {
    /* Die ID wird vor dem Zustandswechsel erzeugt, damit nach dem
       Anlegen direkt zur neuen Region gesprungen werden kann. */
    const neueId = modal.objekt ? null : uid();
    setDb((prev) => ({
      ...prev,
      regions: modal.objekt
        ? ersetzeOderErgaenze(prev.regions, modal.objekt.id, werte, modal.objekt)
        : [...prev.regions, { id: neueId, ...werte }],
    }));
    schliesseModal();
    if (neueId) geheZu({ view: "region", id: neueId });
    return null;
  };

  const speichernWinzer = (werte, neueRegion = null) => {
    const neueId = modal.objekt ? null : uid();
    const neueRegionId = neueRegion ? uid() : null;
    setDb((prev) => {
      let regions = prev.regions;
      let regionId = werte.regionId;
      if (neueRegion) {
        regionId = neueRegionId;
        regions = [...regions, { id: regionId, ...neueRegion }];
      }
      const winzerWerte = { ...werte, regionId };
      return {
        ...prev,
        regions,
        winzer: modal.objekt
          ? ersetzeOderErgaenze(prev.winzer, modal.objekt.id, winzerWerte, modal.objekt)
          : [...prev.winzer, { id: neueId, ...winzerWerte }],
      };
    });
    schliesseModal();
    if (neueId) geheZu({ view: "winzerDetail", id: neueId });
    return null;
  };

  const speichernWein = (werte, neuerWinzer = null, neueRegion = null) => {
    const neueId = modal.objekt ? null : uid();
    const neueWinzerId = neuerWinzer ? uid() : null;
    const neueRegionId = neueRegion ? uid() : null;
    /* Wurde in der Katalogsuche ein Winzer gewählt, wird er jetzt —
       und erst jetzt — samt Region übernommen. */
    const katalogWinzerId = modal.kontext ? modal.kontext.katalogWinzerId : null;
    setDb((prev) => {
      let stand = prev;
      if (katalog && katalogWinzerId && werte.winzerId === katalogWinzerId
        && !stand.winzer.some((x) => x.id === katalogWinzerId)) {
        stand = uebernehmeWinzer(stand, katalog, katalogWinzerId).db;
      }
      let regions = stand.regions;
      let winzer = stand.winzer;
      let winzerId = werte.winzerId;
      if (neuerWinzer) {
        let regionId = neuerWinzer.regionId;
        if (neueRegion) {
          regionId = neueRegionId;
          regions = [...regions, { id: regionId, ...neueRegion }];
        }
        winzerId = neueWinzerId;
        winzer = [...winzer, { id: winzerId, ...neuerWinzer, regionId }];
      }
      const weinWerte = { ...werte, winzerId };
      return {
        ...stand,
        regions, winzer,
        /* Stand das Objekt nur im Katalog (Kuratorensicht), wird es
           beim Bearbeiten in das eigene Kellerbuch übernommen. */
        weine: modal.objekt
          ? ersetzeOderErgaenze(stand.weine, modal.objekt.id, weinWerte,
            { ...modal.objekt, jahrgaenge: modal.objekt.jahrgaenge || [] })
          : [...stand.weine, { id: neueId, ...weinWerte, jahrgaenge: [] }],
      };
    });
    schliesseModal();
    if (neueId) geheZu({ view: "wein", id: neueId });
    return null;
  };

  /* Rundum-Etikett ablegen. Das neue Bild ist zu diesem Zeitpunkt
     schon hochgeladen (oder wartet); ein ersetztes wird gelöscht —
     wie beim Etikett hat jede Aufnahme ihren eigenen Pfad. */
  const speichernRundum = (weinId, jgId, rundum) => {
    const wein = db.weine.find((w) => w.id === weinId);
    const jg = wein && wein.jahrgaenge.find((j) => j.id === jgId);
    const alt = jg && jg.rundum;
    setDb((prev) => ({
      ...prev,
      weine: prev.weine.map((w) => w.id !== weinId ? w : {
        ...w, jahrgaenge: w.jahrgaenge.map((j) => j.id !== jgId ? j : { ...j, rundum }),
      }),
    }));
    if (alt && alt.pfad !== rundum.pfad) fotosLoeschen([alt.pfad, alt.thumb].filter(Boolean));
    schliesseModal();
  };

  const speichernJahrgang = (werte) => {
    const { weinId, jahrgangId } = modal.kontext;
    /* Aus der Sicht lesen: Der Wein kann nur im Katalog stehen. Beim
       Schreiben wird er dann mit übernommen (siehe unten) — genau
       dafür ist `ersetzeOderErgaenze` da. */
    const wein = sichtDb.weine.find((w) => w.id === weinId);
    if (!wein) return "Der Wein wurde nicht gefunden.";
    const nurImKatalog = !!wein.nurKatalog;
    /* Ein Katalogwein bringt beim Übernehmen seine Jahrgänge NICHT
       mit — die sind Vorlagen, keine eigenen Flaschen. Angelegt wird
       nur der eine, den der Nutzer gerade wählt. */
    const bestandsJahrgaenge = nurImKatalog ? [] : wein.jahrgaenge;
    /* Nur echte Jahrgänge dürfen nicht doppelt sein; mehrere N.V.
       (z. B. verschiedene Champagner-Assemblagen) sind erlaubt. */
    if (werte.jahr !== NV) {
      const doppelt = bestandsJahrgaenge.some((j) => j.jahr === werte.jahr && j.id !== jahrgangId);
      if (doppelt) return `Für ${jahrLabel(werte.jahr)} existiert bereits ein Jahrgang dieses Weins.`;
    }
    const neueId = jahrgangId || werte.id || uid();
    /* Ein aus dem Katalog übernommener Jahrgang behält dessen ID —
       er darf dann nicht schon im Kellerbuch stehen. */
    if (!jahrgangId && werte.id && bestandsJahrgaenge.some((j) => j.id === werte.id))
      return "Dieser Jahrgang aus dem Katalog ist bereits angelegt.";
    /* Anfangsbestand eines neuen Jahrgangs als Zugang protokollieren —
       je Flaschengröße eine Bewegung, mit dem erfassten Jahrgangspreis
       als Einstand. */
    let startBewegungen = [];
    if (!jahrgangId && werte.bestaende) {
      const jetzt = new Date().toISOString();
      for (const g of FLASCHENGROESSEN) {
        const menge = werte.bestaende[g.key] || 0;
        if (menge > 0) {
          startBewegungen.push({
            id: uid(), art: "zugang", weinId, jgId: neueId, jahr: werte.jahr,
            groesse: g.key, menge, datum: jetzt,
            preis: werte.preis != null ? werte.preis : null,
          });
        }
      }
    }
    setDb((prev) => ({
      ...prev,
      /* Stand der Wein nur im Katalog, wird er hier ins eigene
         Kellerbuch übernommen — mit Winzer und Region, sonst zeigte
         der neue Eintrag ins Leere. */
      ...(nurImKatalog && katalog
        ? uebernehmeWein(prev, katalog, weinId).db
        : {}),
      weine: (nurImKatalog && katalog
        ? uebernehmeWein(prev, katalog, weinId).db.weine
        : prev.weine).map((w) => {
        if (w.id !== weinId) return w;
        const eigeneJg = nurImKatalog ? [] : w.jahrgaenge;
        const jahrgaenge = jahrgangId
          ? eigeneJg.map((j) => j.id === jahrgangId ? { ...j, ...werte, id: jahrgangId } : j)
          : [...eigeneJg, { ...werte, id: neueId }];
        return { ...w, jahrgaenge };
      }),
      bewegungen: startBewegungen.length ? [...(prev.bewegungen || []), ...startBewegungen] : prev.bewegungen,
      /* Bei Jahrgangswechsel folgt das jahr-Feld der Verweise (Anzeige);
         die stabile Verknüpfung über jgId bleibt ohnehin erhalten. */
      kritiken: jahrgangId ? prev.kritiken.map((k) => k.jgId === jahrgangId ? { ...k, jahr: werte.jahr } : k) : prev.kritiken,
      entnahmen: jahrgangId ? (prev.entnahmen || []).map((e) => e.jgId === jahrgangId ? { ...e, jahr: werte.jahr } : e) : prev.entnahmen,
    }));
    schliesseModal();
    return null;
  };

  const speichernKritik = (werte) => {
    const { weinId } = modal.kontext;
    setDb((prev) => ({
      ...prev,
      kritiken: modal.objekt
        ? prev.kritiken.map((k) => k.id === modal.objekt.id ? { ...k, ...werte } : k)
        /* Zeitstempel nur beim Anlegen: Er trägt die Kritik in den
           Trinkverlauf ein. Beim Bearbeiten bleibt der ursprüngliche
           stehen — sonst wanderte eine korrigierte Notiz von 2019
           ans obere Ende der Chronik. */
        : [...prev.kritiken, {
            id: uid(), weinId, erfasst: new Date().toISOString(),
            /* Über die Oberfläche erfasste Kritiken sind immer die
               Aufzeichnung des Nutzers — auch wenn als Quelle ein
               fremder Kritiker eingetragen ist. */
            istEigene: true, ...werte,
          }],
    }));
    schliesseModal();
    return null;
  };

  /* ── Kritik erfassen und zuordnen ─────────────────────────────
     Ein Vorgang, drei Ausgänge (siehe formulare/kritik.jsx). Alles
     Nötige entsteht in EINEM setDb: Wären Winzer, Wein, Jahrgang und
     Kritik vier Schritte, gäbe es Zwischenstände, in denen ein
     halbes Gebilde im Kellerbuch stünde — und der Speichereffekt
     schriebe jeden davon zum Server.

     Die IDs werden vorher gezogen, weil danach dorthin gesprungen
     wird und der neue Zustand dafür nicht abgewartet werden kann. */
  const speichernSchnellkritik = (r) => {
    const bestehend = modal && modal.objekt ? modal.objekt : null;
    const neueWinzerId = uid();
    const neueWeinId = uid();
    const neueJgId = uid();
    const neueRegionId = uid();
    const kat = katalogAktiv ? katalog : null;

    /* Wohin gehört die Kritik am Ende? */
    let zielWeinId = null;
    let zielJgId = null;
    if (r.modus === "neuerWein") { zielWeinId = neueWeinId; zielJgId = neueJgId; }
    else if (r.modus === "wein") {
      zielWeinId = r.weinId;
      zielJgId = r.jgId || neueJgId;
    }

    /* Etikett, das durch das neue verdrängt wird — muss vom Server
       weg, sonst bleibt eine verwaiste Datei liegen. */
    const verdraengt = [];
    if (zielJgId && r.foto) {
      const wein = db.weine.find((w) => w.id === zielWeinId);
      const jg = wein ? wein.jahrgaenge.find((j) => j.id === zielJgId) : null;
      const alt = jg && jg.foto;
      if (alt && r.fotoUebernehmen) verdraengt.push(alt.pfad, alt.thumb);
      if (alt && !r.fotoUebernehmen) verdraengt.push(r.foto.pfad, r.foto.thumb);
    }
    const fotoAnJahrgang = zielJgId && r.foto && r.fotoUebernehmen !== false ? r.foto : null;

    setDb((prev) => {
      /* Zuerst holen, was aus dem Katalog stammt — Wein, Winzer oder
         Region samt allem, woran sie hängen. Erst danach kann darauf
         verwiesen werden. */
      let stand = prev;
      if (kat) {
        if (r.modus === "wein" && r.weinId && !stand.weine.some((x) => x.id === r.weinId)) {
          stand = uebernehmeWein(stand, kat, r.weinId).db;
        }
        if (r.modus === "neuerWein") {
          if (r.winzer.id && !stand.winzer.some((x) => x.id === r.winzer.id)) {
            stand = uebernehmeWinzer(stand, kat, r.winzer.id).db;
          }
          if (r.winzer.regionId && !stand.regions.some((x) => x.id === r.winzer.regionId)) {
            stand = uebernehmeRegion(stand, kat, r.winzer.regionId).db;
          }
        }
      }

      let regions = stand.regions;
      let winzer = stand.winzer;
      let weine = stand.weine;

      if (r.modus === "neuerWein") {
        let regionId = r.winzer.regionId;
        if (r.neueRegion) {
          regionId = neueRegionId;
          regions = [...regions, { id: regionId, ...r.neueRegion }];
        }
        const winzerId = r.winzer.id || neueWinzerId;
        if (!r.winzer.id) {
          winzer = [...winzer, { id: neueWinzerId, name: r.winzer.name, regionId }];
        }
        weine = [...weine, {
          id: neueWeinId, name: r.wein.name, typ: r.wein.typ, winzerId,
          jahrgaenge: [{ id: neueJgId, jahr: r.jahr, bestaende: {}, ...(fotoAnJahrgang ? { foto: fotoAnJahrgang } : {}) }],
        }];
      } else if (r.modus === "wein") {
        weine = weine.map((w) => {
          if (w.id !== r.weinId) return w;
          if (r.jgId) {
            return fotoAnJahrgang
              ? { ...w, jahrgaenge: w.jahrgaenge.map((j) => j.id !== r.jgId ? j : { ...j, foto: fotoAnJahrgang }) }
              : w;
          }
          return {
            ...w,
            jahrgaenge: [...w.jahrgaenge, {
              id: neueJgId, jahr: r.neuerJahrgang, bestaende: {},
              ...(fotoAnJahrgang ? { foto: fotoAnJahrgang } : {}),
            }],
          };
        });
      }

      /* Die Kritik selbst — neu angelegt oder die offene ergänzt. */
      const jahr = r.modus === "neuerWein" ? r.jahr
        : (r.modus === "wein" && !r.jgId) ? r.neuerJahrgang
        : (() => {
            const w = weine.find((x) => x.id === zielWeinId);
            const j = w && w.jahrgaenge.find((x) => x.id === zielJgId);
            return j ? j.jahr : NV;
          })();

      const zuordnung = r.modus === "offen"
        ? { weinId: null, jgId: null, jahr: null, weinText: r.weinText, foto: r.foto || null }
        : { weinId: zielWeinId, jgId: zielJgId, jahr };

      const kritiken = bestehend
        ? stand.kritiken.map((k) => {
            if (k.id !== bestehend.id) return k;
            const { weinText, foto, ...rest } = k;
            return { ...rest, ...zuordnung };
          })
        : [...stand.kritiken, {
            id: r.id, erfasst: new Date().toISOString(), istEigene: true,
            ...r.bewertung, ...zuordnung,
          }];

      return { ...stand, regions, winzer, weine, kritiken };
    });

    const wegPfade = verdraengt.filter(Boolean);
    if (wegPfade.length > 0) fotosLoeschen(wegPfade);

    /* Nach dem Zuordnen dorthin springen, wo die Kritik nun steht.
       Dabei ALLE Dialoge schließen und nicht über `modal.zurueck` in
       den Trinkverlauf zurückkehren — der legte sich sonst genau über
       die Seite, die hier gezeigt werden soll. Eine offen gebliebene
       Kritik bleibt dagegen, wo sie ist: Dort ist der Verlauf der
       richtige Ort, um weiterzumachen. */
    if (zielWeinId && zielJgId) {
      setModal(null);
      springeZu({ view: "jahrgang", weinId: zielWeinId, jgId: zielJgId });
    } else {
      schliesseModal();
    }
    return null;
  };


  /* ── Löschen (mit referenzieller Integrität) ── */
  const loescheRegion = (id) => {
    setDb((prev) => ({ ...prev, regions: prev.regions.filter((r) => r.id !== id) }));
  };
  const loescheWinzer = (id) => {
    setDb((prev) => ({ ...prev, winzer: prev.winzer.filter((w) => w.id !== id) }));
  };
  const loescheWein = (id) => {
    const wein = db.weine.find((w) => w.id === id);
    const pfade = wein ? wein.jahrgaenge.flatMap(jahrgangBildPfade) : [];
    setDb((prev) => ({
      ...prev,
      weine: prev.weine.filter((w) => w.id !== id),
      kritiken: prev.kritiken.filter((k) => k.weinId !== id),
    }));
    fotosLoeschen(pfade);
  };
  const loescheJahrgang = (weinId, jgId) => {
    const wein = db.weine.find((w) => w.id === weinId);
    const jg = wein && wein.jahrgaenge.find((j) => j.id === jgId);
    const pfade = jahrgangBildPfade(jg);
    setDb((prev) => ({
      ...prev,
      weine: prev.weine.map((w) => w.id !== weinId ? w : { ...w, jahrgaenge: w.jahrgaenge.filter((j) => j.id !== jgId) }),
      kritiken: prev.kritiken.filter((k) => k.jgId !== jgId),
      entnahmen: (prev.entnahmen || []).filter((e) => e.jgId !== jgId),
      bewegungen: (prev.bewegungen || []).filter((b) => b.jgId !== jgId),
    }));
    fotosLoeschen(pfade);
  };
  const loescheKritik = (id) => {
    /* Eine offene Kritik trägt ihr Etikett selbst — es hängt an
       keinem Jahrgang und bliebe sonst verwaist liegen. */
    const k = db.kritiken.find((x) => x.id === id);
    const pfade = k && istOffeneKritik(k) && k.foto ? [k.foto.pfad, k.foto.thumb].filter(Boolean) : [];
    setDb((prev) => ({ ...prev, kritiken: prev.kritiken.filter((x) => x.id !== id) }));
    if (pfade.length > 0) fotosLoeschen(pfade);
    schliesseModal();
  };
  /* Lieblingswein-Markierung umschalten (Flag am Wein). */
  const setzeFavorit = (weinId) => {
    setDb((prev) => ({
      ...prev,
      weine: prev.weine.map((w) => w.id === weinId ? { ...w, favorit: !w.favorit } : w),
    }));
  };

  /* Keller leeren: Bestände/Jahrgänge, Kritiken und Historie entfernen.
     Mit `auchStammdaten` zusätzlich Weine, Winzer und Regionen. */
  const leereKeller = (auchStammdaten) => {
    setDb((prev) => {
      if (auchStammdaten) {
        return {
          ...prev,
          regions: [], winzer: [], weine: [],
          kritiken: [], entnahmen: [], bewegungen: [],
        };
      }
      return {
        ...prev,
        weine: prev.weine.map((w) => ({ ...w, jahrgaenge: [] })),
        kritiken: [], entnahmen: [], bewegungen: [],
      };
    });
    /* Beide Varianten entfernen sämtliche Jahrgänge — damit auch alle Fotos. */
    fotosLoeschen(alleFotoPfade(db));
    setVerlauf([{ view: "keller" }]);
    schliesseModal();
  };

  /* Nach einem Import verwaiste Dateien entfernen (Fotos, deren
     Jahrgang die importierte Datei nicht mehr kennt). */
  const fotosAufraeumen = async (stand) => {
    try {
      await fetch("/api/fotos/aufraeumen", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ behalten: alleFotoPfade(stand) }),
      });
    } catch (e) { /* nicht kritisch */ }
  };

  /* ── Excel-Export / Vorlage / Import ── */
  const exportKeller = async () => {
    if (!db) return;
    setImpexStatus({ typ: "laed", text: "Export wird erstellt …" });
    try { await exportiereBestand(db); setImpexStatus(null); }
    catch (e) { setImpexStatus({ typ: "fehler", text: e.message || "Export fehlgeschlagen." }); }
  };
  const vorlageHolen = async () => {
    setImpexStatus({ typ: "laed", text: "Vorlage wird erstellt …" });
    try { await ladeVorlage(); setImpexStatus(null); }
    catch (e) { setImpexStatus({ typ: "fehler", text: e.message || "Vorlage fehlgeschlagen." }); }
  };
  const importDialog = () => { if (dateiRef.current) { dateiRef.current.value = ""; dateiRef.current.click(); } };
  const importDateiGewaehlt = async (e) => {
    const datei = e.target.files && e.target.files[0];
    if (!datei) return;
    setImpexStatus({ typ: "laed", text: "Datei wird gelesen …" });
    try {
      const roh = await leseExcel(datei);
      const { neu, bericht } = baueImportDb(db, roh);
      setDb(neu);
      setVerlauf([{ view: "keller" }]);
      setImpexStatus(null);
      setModal({ typ: "importBericht", kontext: { bericht } });
      /* Gelegenheit für den Aufräumlauf: entfernt Dateien, die kein
         Jahrgang mehr referenziert (z. B. abgebrochene Uploads). */
      fotosAufraeumen(neu);
    } catch (err) {
      setImpexStatus({ typ: "fehler", text: err.message || "Die Datei konnte nicht gelesen werden." });
    }
  };

  /* ── Wetterdaten für alle Regionen & Jahrgänge laden ──
     Plan und Lauf in dienste/wetterlauf.js: was fehlt, Warten an der
     Minutengrenze, Abbruch an Stunde/Tag, Jahrgänge aus der Reihe. */
  const wetterLaufAktiv = useRef(false);
  const wetterAlleLaden = async (modus) => {
    if (wetterLaufAktiv.current) return;
    wetterLaufAktiv.current = true;
    try {
      const plan = wetterPlan(db, modus);
      await wetterLauf(plan, {
        klimaCache: db.klimaCache || {},
        holeKlima: ladeKlimareihe,
        holeJahrgang: ladeWitterung,
        /* Jede Reihe sofort ins Kellerbuch: Wer das Fenster schließt,
           behält, was schon geholt ist. */
        uebernehme: (teil) => setDb((prev) => wendeAn(prev, teil)),
        melde: (stand) => setWetterStatus({ ...stand, modus }),
      });
    } finally {
      wetterLaufAktiv.current = false;
    }
  };

  /* Vorschlagslisten aus bestehenden Einträgen für die Autovervollständigung.
     Achtung: db ist vor dem ersten Laden null — dann leere Listen liefern.
     Auch die Abhängigkeiten dürfen nicht in ein null-db greifen. */
  /* Der Zähler für offene Dubletten stand bisher offen im Rumpf und
     lief damit bei JEDEM Render — auch bei jedem Ansichtswechsel.
     Der Vergleich geht über alle eigenen Objekte gegen den ganzen
     Katalog; bei einem freigegebenen Altbestand (ohne `herkunft`)
     waren das gemessen über drei Sekunden je Render. */
  const offeneDubletten = useMemo(
    () => (katalogAktiv && katalog && db ? offeneEntscheidungen(db, katalog).filter((e) => e.sperrt).length : 0),
    [katalogAktiv, katalog, db]);

  /* Kritik-Einstellungen des Kontos. Kommen aus /api/ich und werden
     nach dem Speichern unter „Mein Konto“ hier nachgeführt, damit das
     nächste Formular sie schon kennt. */
  const kritikPrefs = useMemo(() => ({
    schema: (nutzer && nutzer.kritikSchema) || "p100",
    geteilt: !nutzer || nutzer.kritikGeteilt !== false,
  }), [nutzer]);
  kritikPrefsRef.current = kritikPrefs;

  /* Kritik-Einstellungen speichern. Der Nutzerzustand wird sofort
     nachgeführt, damit das nächste Formular sie kennt; bei einem
     Fehler bleibt der alte Wert stehen. */
  const speichereKritikPrefs = async (aenderung) => {
    const naechste = { schema: kritikPrefs.schema, geteilt: kritikPrefs.geteilt, ...aenderung };
    const vorher = kritikPrefs;
    setNutzer((n) => (n ? { ...n, kritikSchema: naechste.schema, kritikGeteilt: naechste.geteilt } : n));
    try {
      const r = await fetch("/api/konto/kritik", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(naechste),
      });
      if (!r.ok) throw new Error("abgelehnt");
      /* Das Abschalten wirkt rückwirkend: leere Liste zum Server. */
      if (db && katalogAktiv) kritikenTeilen(db, naechste.geteilt).catch(() => {});
    } catch (e) {
      setNutzer((n) => (n ? { ...n, kritikSchema: vorher.schema, kritikGeteilt: vorher.geteilt } : n));
    }
  };

  const vorschlaege = useMemo(() => {
    if (!db) return { rebsorte: [], appellation: [], klassifikation: [], label: [], ort: [], land: [], verschluss: [], lagerort: [], kritiker: [], anlass: [], pairing: [] };
    return {
      rebsorte: rebsortenListe(db.weine),
      appellation: eindeutigeWerte(db.weine, "appellation"),
      klassifikation: eindeutigeWerte(db.weine, "klassifikation"),
      label: eindeutigeWerte(db.weine, "label"),
      ort: eindeutigeWerte(db.winzer, "ort"),
      land: eindeutigeWerte(db.regions, "land"),
      verschluss: eindeutigeWerte(db.weine.flatMap((w) => w.jahrgaenge), "verschluss"),
      lagerort: eindeutigeWerte(db.weine.flatMap((w) => w.jahrgaenge), "lagerort"),
      kritiker: eindeutigeWerte(db.kritiken || [], "kritiker"),
      anlass: eindeutigeWerte(db.kritiken || [], "anlass"),
      pairing: eindeutigeWerte(db.kritiken || [], "pairing", { split: true }),
      haendler: eindeutigeWerte(db.bewegungen || [], "haendler"),
      kapsel: eindeutigeWerte(db.weine.flatMap((w) => w.jahrgaenge), "kapsel"),
    };
  }, [db]);

  if (nutzer === null || nutzer === false) {
    return (
      <div className="wl-root">
        <style>{CSS}</style>
        {nutzer === null ? (
          <div className="wl-laden">
            <Logo groesse={52} />
            <span className="wl-marke">WineLake</span>
            <span>{t("Anmeldung wird geprüft …")}</span>
          </div>
        ) : (
          <AnmeldeAnsicht onAngemeldet={(k) => { speichereKonto(k); setNutzer(k); }} />
        )}
      </div>
    );
  }

  if (!db) {
    return (
      <div className="wl-root">
        <style>{CSS}</style>
        <div className="wl-laden">
          <Logo groesse={52} />
          <span className="wl-marke">WineLake</span>
          <span>{t("Kellerbuch wird geöffnet …")}</span>
        </div>
      </div>
    );
  }

  const NAV = [
    ["keller", "Keller", ["keller"]],
    ["weine", "Weine", ["weine", "wein"]],
    ["winzer", "Winzer", ["winzer", "winzerDetail"]],
    ["regionen", "Regionen", ["regionen", "region"]],
  ];

  const winzerSortiert = [...db.winzer].sort(sortDe);
  const regionenSortiert = [...db.regions].sort(sortDe);

  /* Der in der Katalogsuche gewählte Winzer steht noch nicht im
     Kellerbuch — für die Vorwahl im Weinformular wird er der Liste
     vorangestellt; übernommen wird er erst beim Speichern. */
  const winzerFuerWeinForm = (() => {
    const id = modal && modal.typ === "wein" && modal.kontext ? modal.kontext.katalogWinzerId : null;
    if (!id || !katalog || db.winzer.some((w) => w.id === id)) return winzerSortiert;
    const kw = katalog.winzer.find((w) => w.id === id);
    return kw ? [kw, ...winzerSortiert] : winzerSortiert;
  })();

  const modalWein = modal && ["kritik", "jahrgang", "entnahme", "zugang", "bewegung", "rundum"].includes(modal.typ)
    /* Aus `sichtDb`, nicht aus `db`: In der Sicht „Alle Weine“ kann
       der Wein nur im Katalog stehen. Aus `db` gelesen wäre er dort
       `null` — der Dialog erschiene gar nicht erst, und beim Anlegen
       eines Jahrgangs fehlten die Katalogjahrgänge. Übernommen ins
       eigene Kellerbuch wird er beim Speichern (ersetzeOderErgaenze). */
    ? sichtDb.weine.find((w) => w.id === (modal.kontext ? modal.kontext.weinId : null))
    : null;
  const modalJahrgang = modal && ["entnahme", "zugang", "bewegung", "rundum"].includes(modal.typ) && modalWein
    ? jahrgangFuer(modalWein, modal.kontext.jgId, modal.kontext.jahr)
    : null;

  /* Jahrgänge, die der Katalog zu diesem Wein kennt und die im eigenen
     Kellerbuch noch fehlen — Auswahl beim Anlegen eines Jahrgangs.
     Bewusst ohne useMemo: die Stelle liegt hinter den frühen
     Rückgaben oben, und die Liste ist kurz. */
  const offeneKatalogJahrgaenge = (() => {
    if (!katalogAktiv || !katalog || !modalWein) return [];
    const kw = katalog.weine.find((w) => w.id === modalWein.id);
    if (!kw) return [];
    /* Nur die WIRKLICH eigenen Jahrgänge ausschließen. In der Sicht
       „Alle Weine“ trägt `modalWein` bereits die Katalogjahrgänge —
       gegen die gefiltert bliebe nichts übrig, und die Auswahl wäre
       genau dort leer, wo sie am nötigsten ist. */
    const eigenerWein = (db.weine || []).find((w) => w.id === modalWein.id);
    const eigene = (eigenerWein && !eigenerWein.nurKatalog) ? eigenerWein.jahrgaenge : [];
    const vorhandeneIds = new Set(eigene.map((j) => j.id));
    const vorhandeneJahre = new Set(eigene.map((j) => j.jahr));
    return (kw.jahrgaenge || [])
      .filter((j) => !vorhandeneIds.has(j.id) && !vorhandeneJahre.has(j.jahr))
      .sort((a, b) => (b.jahr || 0) - (a.jahr || 0));
  })();

  return (
    <div className="wl-root">
      <style>{CSS}</style>

      <div className="wl-shell">
        <header className="wl-header">
          <div className="wl-kopfmarke">
            <HauptMenue nutzer={nutzer} abmelden={abmelden}
              sync={sync} onSync={synchronisieren} ungesichert={ungesichert} wartendeFotos={wartendeFotos} lokalFehler={lokalFehler}
              modus={istCloud ? "cloud" : "lokal"} onModus={modusWechseln}
              sprache={nutzer.sprache || "de"}
              kritikSchema={kritikPrefs.schema} kritikGeteilt={kritikPrefs.geteilt}
              onKritikPrefs={speichereKritikPrefs} onSprache={spracheWechseln}
              katalogGesperrt={katalogGesperrt}
              offeneAnzahl={katalogVorschlaege.filter((v) => v.status === "offen").length}
              konflikte={abweichungen.length} neuEntschieden={neuEntschieden} adminOffen={adminOffen}
              onHistorie={() => oeffneModal({ typ: "historie" })}
              dubletten={offeneDubletten}
              onZusammenfuehren={() => oeffneModal({ typ: "zusammenfuehren" })}
              onVorschlaege={() => { oeffneModal({ typ: "vorschlaege", gesehen: vorschlaegeGesehen }); vorschlaegeGesehenMerken(); }}
              onAdminVorschlaege={() => oeffneModal({ typ: "adminVorschlaege" })}
              sicht={sicht} setSicht={setSicht}
              geheZuStatistik={() => springeZu({ view: "statistik" })}
              onKonto={() => oeffneModal({ typ: "konto" })}
              onWeinkarten={() => oeffneModal({ typ: "weinkarten" })}
              onTeilen={() => oeffneModal({ typ: "teilen" })}
              onKellerLoeschen={() => oeffneModal({ typ: "kellerLoeschen" })}
              onExport={exportKeller} onVorlage={vorlageHolen} onImport={importDialog}
              onWetter={() => { setWetterStatus(null); setModal({ typ: "wetterLaden" }); }}
              onTrinkverlauf={() => oeffneModal({ typ: "trinkverlauf" })}
              onInfo={() => oeffneModal({ typ: "info" })}
              onVerwaltung={() => oeffneModal({ typ: "admin" })} />
            <Logo groesse={44} />
            <span className="wl-marke">WineLake</span>
          </div>
          <nav className="wl-nav" aria-label={t("Hauptnavigation")}>
            {NAV.map(([ziel, label, aktiveViews]) => (
              <button
                key={ziel}
                className={aktiveViews.includes(route.view) ? "aktiv" : ""}
                aria-current={aktiveViews.includes(route.view) ? "page" : undefined}
                onClick={() => springeZu({ view: ziel })}
              >
                {t(label)}
              </button>
            ))}
          </nav>
        </header>

        <main>
          <ZurueckLeiste sichtbar={kannZurueck} onBack={zurueck} />
          {route.view === "keller" && (
            <KellerAnsicht db={sichtDb}
            vorgabe={route.filter}
              nurBestand={nurBestand && !zeigeAlle}
              geheZu={geheZu} oeffneModal={oeffneModal} loescheJahrgang={loescheJahrgang} setzeFavorit={setzeFavorit} />
          )}
          {route.view === "weine" && (
            <WeineAnsicht db={sichtDb}
            nurBestand={nurBestand && !zeigeAlle}
              geheZu={geheZu} oeffneModal={oeffneModal} loescheWein={loescheWein} />
          )}
          {route.view === "wein" && (
            <WeinDetail id={route.id} db={sichtDb} nurBestand={nurBestand && !zeigeAlle} geheZu={geheZu}
              fremdeKritiken={geteilteKritiken}
              oeffneModal={oeffneModal} loescheWein={loescheWein} loescheJahrgang={loescheJahrgang} setzeFavorit={setzeFavorit} />
          )}
          {route.view === "winzer" && (
            <WinzerAnsicht db={sichtDb}
            nurBestand={nurBestand && !zeigeAlle}
              geheZu={geheZu} oeffneModal={oeffneModal} loescheWinzer={loescheWinzer} />
          )}
          {route.view === "winzerDetail" && (
            <WinzerDetail id={route.id} db={sichtDb} nurBestand={nurBestand && !zeigeAlle} geheZu={geheZu} oeffneModal={oeffneModal} loescheWinzer={loescheWinzer} />
          )}
          {route.view === "regionen" && (
            <RegionenAnsicht db={sichtDb} land={route.land}
              nurBestand={nurBestand && !zeigeAlle}
              geheZu={geheZu} oeffneModal={oeffneModal} loescheRegion={loescheRegion} />
          )}
          {route.view === "region" && (
            <RegionDetail id={route.id} db={sichtDb} nurBestand={nurBestand && !zeigeAlle} setDb={setDb} geheZu={geheZu} oeffneModal={oeffneModal}
              darfWetter={!!nutzer.darfWetter}
              loescheRegion={loescheRegion} vorwahlJahr={route.jahr} vorwahlAppellation={route.appellation} />
          )}
          {route.view === "jahrgang" && (
            <JahrgangDetail weinId={route.weinId} jgId={route.jgId} db={sichtDb} setDb={setDb}
              darfWetter={!!nutzer.darfWetter}
              geheZu={geheZu} oeffneModal={oeffneModal} loescheJahrgang={loescheJahrgang} />
          )}
          {route.view === "statistik" && <StatistikAnsicht db={db} />}
        </main>

        <footer className="wl-fuss">
          <span>{t("WineLake · Witterung: Open-Meteo Historical Weather API · Karten: OpenStreetMap-Mitwirkende")}</span>
        </footer>
      </div>

      {modal && modal.typ === "sync" && (
        <Modal titel="Daten synchronisieren" onClose={schliesseSync}>
          <SyncPanel lauf={syncLauf} db={db}
            onLokal={konfliktLokalBehalten} onServer={konfliktServerBehalten}
            onZusammenfuehren={konfliktZusammenfuehren}
            onWiederholen={synchronisieren} onClose={schliesseSync} />
        </Modal>
      )}
      {modal && modal.typ === "schnellkritik" && (
        <Modal titel={modal.objekt ? "Kritik zuordnen" : "Kritik erfassen"} onClose={schliesseModal}>
          <SchnellKritikForm
            objekt={modal.objekt || null}
            weine={db.weine} winzerListe={db.winzer} regionen={db.regions}
            katalog={katalogAktiv ? katalog : null}
            vorschlaege={vorschlaege} kritikPrefs={kritikPrefs}
            onSave={speichernSchnellkritik}
            onCancel={schliesseModal}
            onDelete={modal.objekt ? () => loescheKritik(modal.objekt.id) : null}
          />
        </Modal>
      )}
      {modal && modal.typ === "trinkverlauf" && (
        <Modal titel="Trinkverlauf" onClose={schliesseModal}>
          <TrinkverlaufPanel db={sichtDb}
            geheZu={(ziel) => { schliesseModal(); geheZu(ziel); }}
            onKritikErfassen={() => setModal({ typ: "schnellkritik", zurueck: { typ: "trinkverlauf" } })}
            oeffneModal={oeffneModal} />
        </Modal>
      )}
      {modal && modal.typ === "info" && (
        <Modal titel="Info" onClose={schliesseModal}>
          <InfoPanel nutzer={nutzer} istCloud={istCloud} />
        </Modal>
      )}
      {modal && modal.typ === "admin" && (
        <Modal titel="Verwaltung" onClose={schliesseModal}>
          <AdminPanel onClose={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "kellerLoeschen" && (
        <Modal titel="Keller löschen" onClose={schliesseModal}>
          <KellerLoeschenForm db={db} onLoeschen={leereKeller} onCancel={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "zusammenfuehren" && (
        <Modal titel="Zusammenführen" onClose={schliesseModal}>
          <ZusammenfuehrenPanel db={db} setDb={setDb} katalog={katalogAktiv ? katalog : null}
            istAdmin={!!nutzer.istAdmin} onClose={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "historie" && (
        <Modal titel="Änderungen im Katalog" onClose={schliesseModal}>
          <Historie db={db} abweichungen={abweichungen} ergebnisse={historie} namen={namenKarte}
            onUebernehmen={(id) => setDb((prev) => abweichungUebernehmen(prev, id))}
            onBehalten={(id) => setDb((prev) => abweichungBehalten(prev, id))}
            onClose={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "vorschlaege" && (
        <Modal titel="Meine Vorschläge" onClose={schliesseModal}>
          <MeineVorschlaege vorschlaege={katalogVorschlaege} db={db} namen={namenKarte}
            gesehen={modal.gesehen} zurueckgehalten={zurueckgehalten(db, katalog)} abweichend={weichtAb}
            onZurueckziehen={vorschlagZurueckziehenKlick} onKatalogfassung={katalogfassungWiederherstellen}
            onFreigeben={altbestandFreigeben} onClose={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "adminVorschlaege" && (
        <Modal titel="Katalog-Vorschläge" onClose={schliesseModal}>
          <AdminVorschlaege onClose={schliesseModal} onGeaendert={(n) => {
            if (n != null) setAdminOffen(n);
            /* Der Admin ist selbst Nutzer: Katalog und eigene Vorschläge
               haben sich gerade geändert. */
            katalogAbgleich();
          }} />
        </Modal>
      )}
      {modal && modal.typ === "konto" && (
        <Modal titel="Mein Konto" onClose={schliesseModal}>
          <KontoPanel nutzer={nutzer}
            onEmailGeaendert={(email) => setNutzer((n) => (n ? { ...n, email } : n))}
            onClose={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "teilen" && (
        <Modal titel="Keller teilen" onClose={schliesseModal}>
          <TeilenPanel onClose={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "weinkarten" && (
        <Modal titel="Weinkarten" onClose={schliesseModal}>
          <WeinkartenPanel db={db} setDb={setDb} onClose={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "importBericht" && (
        <Modal titel="Import abgeschlossen" onClose={schliesseModal}>
          <ImportBericht bericht={modal.kontext.bericht} onClose={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "wetterLaden" && (
        <Modal titel="Wetterdaten laden" onClose={schliesseModal}>
          <WetterLadenPanel db={db} status={wetterStatus} onStart={wetterAlleLaden} onClose={schliesseModal} />
        </Modal>
      )}
      <input ref={dateiRef} type="file" accept=".xlsx,.xls" style={{ display: "none" }}
        onChange={importDateiGewaehlt} aria-hidden="true" />
      {impexStatus && (
        <div className={"wl-impex-toast" + (impexStatus.typ === "fehler" ? " ist-fehler" : "")} role="status">
          <span>{impexStatus.text}</span>
          {impexStatus.typ === "fehler" && <button className="wl-impex-schliessen" onClick={() => setImpexStatus(null)} aria-label={t("Schließen")}>×</button>}
        </div>
      )}
      {modal && modal.typ === "region" && (
        <Modal titel={modal.objekt ? "Region bearbeiten" : "Region anlegen"} onClose={schliesseModal}>
          {!modal.objekt && katalogAktiv && (
            <KatalogUebernahme katalog={katalog} art="region"
              onUebernehmen={(o) => ausKatalog("region", o)} />
          )}
          <RegionForm objekt={modal.objekt}
            vorwahlLand={modal.kontext ? modal.kontext.land : null}
            vorschlaege={vorschlaege}
            onSave={speichernRegion} onCancel={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "winzer" && (
        <Modal titel={modal.objekt ? "Winzer bearbeiten" : "Winzer anlegen"} onClose={schliesseModal}>
          {!modal.objekt && katalogAktiv && (
            <KatalogUebernahme katalog={katalog} art="winzer"
              onUebernehmen={(o) => ausKatalog("winzer", o)} />
          )}
          <WinzerForm objekt={modal.objekt} regionen={regionenSortiert}
            vorschlaege={vorschlaege}
            onSave={speichernWinzer} onCancel={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "wein" && (
        <Modal titel={modal.objekt ? "Wein bearbeiten" : "Wein anlegen"} onClose={schliesseModal}>
          {!modal.objekt && katalogAktiv && (
            <KatalogUebernahme katalog={katalog} art="wein"
              onUebernehmen={(o) => ausKatalog("wein", o)}
              onWinzerNutzen={katalogWinzerNutzen} />
          )}
          <WeinForm key={(modal.kontext && modal.kontext.winzerId) || "neu"}
            objekt={modal.objekt} winzerListe={winzerFuerWeinForm} regionen={regionenSortiert}
            vorwahlWinzerId={modal.kontext ? modal.kontext.winzerId : null}
            vorschlaege={vorschlaege}
            onSave={speichernWein} onCancel={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "jahrgang" && modalWein && (
        <Modal titel={`${modal.objekt ? t("Jahrgang bearbeiten") : t("Jahrgang anlegen")} · ${modalWein.name}`} onClose={schliesseModal}>
          <JahrgangForm objekt={modal.objekt} vorschlaege={vorschlaege}
            katalogJahrgaenge={modal.objekt ? [] : offeneKatalogJahrgaenge}
            onSave={speichernJahrgang} onCancel={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "entnahme" && modalWein && modalJahrgang && (
        <Modal titel={`${t("Entnahme")} · ${modalWein.name} ${jahrLabel(modalJahrgang.jahr)}`} onClose={schliesseModal}>
          <EntnahmeForm jahrgang={modalJahrgang} onSave={speichernEntnahme} onCancel={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "zugang" && modalWein && modalJahrgang && (
        <Modal titel={`${t("Zugang")} · ${modalWein.name} ${jahrLabel(modalJahrgang.jahr)}`} onClose={schliesseModal}>
          <ZugangForm jahrgang={modalJahrgang} vorschlaege={vorschlaege} onSave={speichernZugang} onCancel={schliesseModal} />
        </Modal>
      )}
      {modal && modal.typ === "bewegung" && modal.objekt && modalWein && modalJahrgang && (
        <Modal
          titel={`${modal.objekt.art === "zugang" ? t("Zugang bearbeiten") : t("Entnahme bearbeiten")} · ${modalWein.name} ${jahrLabel(modal.objekt.jahr)}`}
          onClose={schliesseModal}>
          <BewegungForm objekt={modal.objekt} jahrgang={modalJahrgang} vorschlaege={vorschlaege}
            onSave={speichernBewegung} onCancel={schliesseModal}
            onDelete={() => loescheBewegung(modal.objekt)} />
        </Modal>
      )}
      {modal && modal.typ === "rundum" && modalWein && modalJahrgang && (
        <RundumAufnahme wein={modalWein} jg={modalJahrgang}
          onSave={(rundum) => speichernRundum(modalWein.id, modalJahrgang.id, rundum)}
          onCancel={schliesseModal} />
      )}
      {modal && modal.typ === "kritik" && modalWein && (
        <Modal titel={modal.objekt ? "Kritik bearbeiten" : "Kritik erfassen"} onClose={schliesseModal}>
          <KritikForm
            objekt={modal.objekt} wein={modalWein}
            vorwahlJahr={modal.kontext ? modal.kontext.jahr : null}
            vorwahlJgId={modal.kontext ? modal.kontext.jgId : null}
            nachEntnahme={modal.kontext ? !!modal.kontext.nachEntnahme : false}
            vorschlaege={vorschlaege} kritikPrefs={kritikPrefs}
            onSave={speichernKritik} onCancel={schliesseModal}
            onDelete={modal.objekt ? () => loescheKritik(modal.objekt.id) : null}
          />
        </Modal>
      )}
    </div>
  );
}

export { AnmeldeAnsicht, HauptMenue, Logo, WineLake };
